var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6AxTandemSingleTandem1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3244.64 800.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-230,.cls-231,.cls-232,.cls-233,.cls-234,.cls-235,.cls-236,.cls-237,.cls-238,.cls-239,.cls-240,.cls-241,.cls-242,.cls-243,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264,.cls-265,.cls-266,.cls-267,.cls-268,.cls-269,.cls-270,.cls-271,.cls-272,.cls-273,.cls-274,.cls-275,.cls-276,.cls-277,.cls-278,.cls-279,.cls-280,.cls-281,.cls-282,.cls-283,.cls-284,.cls-285,.cls-286,.cls-287,.cls-288,.cls-289,.cls-290,.cls-291,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-300,.cls-301,.cls-302,.cls-303,.cls-304,.cls-305,.cls-306,.cls-307,.cls-308,.cls-309{stroke-width:0px;}.cls-2,.cls-305{fill:#414042;}.cls-3{fill:url(#New_Gradient_Swatch_4);}.cls-4{fill:url(#New_Gradient_Swatch_5);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-5);}.cls-6,.cls-165,.cls-261,.cls-310,.cls-275,.cls-278,.cls-279,.cls-280,.cls-282,.cls-283,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-300,.cls-301,.cls-302,.cls-305,.cls-308{mix-blend-mode:multiply;}.cls-311{filter:url(#luminosity-noclip-9);}.cls-312{filter:url(#luminosity-noclip-7);}.cls-313{filter:url(#luminosity-noclip-2);}.cls-314{filter:url(#luminosity-noclip-3);}.cls-315{filter:url(#luminosity-noclip-5);}.cls-7{fill:url(#New_Gradient_Swatch_3-3);}.cls-8{fill:url(#New_Gradient_Swatch_3-4);}.cls-9{fill:url(#New_Gradient_Swatch_3-9);}.cls-10{fill:url(#New_Gradient_Swatch_3-8);}.cls-11{fill:url(#New_Gradient_Swatch_3-7);}.cls-12{fill:url(#New_Gradient_Swatch_3-6);}.cls-13{fill:url(#New_Gradient_Swatch_3-2);}.cls-14{fill:url(#New_Gradient_Swatch_3-5);}.cls-15{fill:url(#New_Gradient_Swatch_4-3);}.cls-16{fill:url(#New_Gradient_Swatch_4-2);}.cls-17{fill:url(#New_Gradient_Swatch_4-6);}.cls-18{fill:url(#New_Gradient_Swatch_4-4);}.cls-19{fill:url(#New_Gradient_Swatch_4-5);}.cls-20{fill:url(#linear-gradient-179);}.cls-21{fill:url(#linear-gradient-177);}.cls-22{fill:url(#linear-gradient-176);}.cls-23{fill:url(#linear-gradient-178);}.cls-24{fill:url(#linear-gradient-120);}.cls-25{fill:url(#linear-gradient-125);}.cls-26{fill:url(#linear-gradient-124);}.cls-27{fill:url(#linear-gradient-126);}.cls-28{fill:url(#linear-gradient-188);}.cls-29{fill:url(#linear-gradient-180);}.cls-30{fill:url(#linear-gradient-184);}.cls-31{fill:url(#linear-gradient-185);}.cls-32{fill:url(#linear-gradient-186);}.cls-33{fill:url(#linear-gradient-187);}.cls-34{fill:url(#linear-gradient-181);}.cls-35{fill:url(#linear-gradient-182);}.cls-36{fill:url(#linear-gradient-183);}.cls-37{fill:url(#linear-gradient-138);}.cls-38{fill:url(#linear-gradient-139);}.cls-39{fill:url(#linear-gradient-134);}.cls-40{fill:url(#linear-gradient-131);}.cls-41{fill:url(#linear-gradient-136);}.cls-42{fill:url(#linear-gradient-132);}.cls-43{fill:url(#linear-gradient-135);}.cls-44{fill:url(#linear-gradient-130);}.cls-45{fill:url(#linear-gradient-133);}.cls-46{fill:url(#linear-gradient-137);}.cls-47{fill:url(#linear-gradient-197);}.cls-48{fill:url(#linear-gradient-196);}.cls-49{fill:url(#linear-gradient-195);}.cls-50{fill:url(#linear-gradient-194);}.cls-51{fill:url(#linear-gradient-189);}.cls-52{fill:url(#linear-gradient-190);}.cls-53{fill:url(#linear-gradient-199);}.cls-54{fill:url(#linear-gradient-100);}.cls-55{fill:url(#linear-gradient-101);}.cls-56{fill:url(#linear-gradient-192);}.cls-57{fill:url(#linear-gradient-191);}.cls-58{fill:url(#linear-gradient-193);}.cls-59{fill:url(#linear-gradient-198);}.cls-60{fill:url(#linear-gradient-123);}.cls-61{fill:url(#linear-gradient-129);}.cls-62{fill:url(#linear-gradient-121);}.cls-63{fill:url(#linear-gradient-122);}.cls-64{fill:url(#linear-gradient-109);}.cls-65{fill:url(#linear-gradient-108);}.cls-66{fill:url(#linear-gradient-106);}.cls-67{fill:url(#linear-gradient-107);}.cls-68{fill:url(#linear-gradient-102);}.cls-69{fill:url(#linear-gradient-104);}.cls-70{fill:url(#linear-gradient-103);}.cls-71{fill:url(#linear-gradient-105);}.cls-72{fill:url(#linear-gradient-117);}.cls-73{fill:url(#linear-gradient-118);}.cls-74{fill:url(#linear-gradient-111);}.cls-75{fill:url(#linear-gradient-112);}.cls-76{fill:url(#linear-gradient-127);}.cls-77{fill:url(#linear-gradient-128);}.cls-78{fill:url(#linear-gradient-110);}.cls-79{fill:url(#linear-gradient-113);}.cls-80{fill:url(#linear-gradient-114);}.cls-81{fill:url(#linear-gradient-115);}.cls-82{fill:url(#linear-gradient-116);}.cls-83{fill:url(#linear-gradient-119);}.cls-84{fill:url(#linear-gradient-245);}.cls-85{fill:url(#linear-gradient-243);}.cls-86{fill:url(#linear-gradient-244);}.cls-87{fill:url(#linear-gradient-248);}.cls-88{fill:url(#linear-gradient-242);}.cls-89{fill:url(#linear-gradient-247);}.cls-90{fill:url(#linear-gradient-241);}.cls-91{fill:url(#linear-gradient-240);}.cls-92{fill:url(#linear-gradient-246);}.cls-93{fill:url(#linear-gradient-253);}.cls-94{fill:url(#linear-gradient-255);}.cls-95{fill:url(#linear-gradient-254);}.cls-96{fill:url(#linear-gradient-252);}.cls-97{fill:url(#linear-gradient-251);}.cls-98{fill:url(#linear-gradient-250);}.cls-99{fill:url(#linear-gradient-173);}.cls-100{fill:url(#linear-gradient-170);}.cls-101{fill:url(#linear-gradient-175);}.cls-102{fill:url(#linear-gradient-174);}.cls-103{fill:url(#linear-gradient-172);}.cls-104{fill:url(#linear-gradient-144);}.cls-105{fill:url(#linear-gradient-145);}.cls-106{fill:url(#linear-gradient-149);}.cls-107{fill:url(#linear-gradient-148);}.cls-108{fill:url(#linear-gradient-171);}.cls-109{fill:url(#linear-gradient-146);}.cls-110{fill:url(#linear-gradient-143);}.cls-111{fill:url(#linear-gradient-169);}.cls-112{fill:url(#linear-gradient-140);}.cls-113{fill:url(#linear-gradient-141);}.cls-114{fill:url(#linear-gradient-147);}.cls-115{fill:url(#linear-gradient-166);}.cls-116{fill:url(#linear-gradient-142);}.cls-117{fill:url(#linear-gradient-168);}.cls-118{fill:url(#linear-gradient-164);}.cls-119{fill:url(#linear-gradient-161);}.cls-120{fill:url(#linear-gradient-163);}.cls-121{fill:url(#linear-gradient-158);}.cls-122{fill:url(#linear-gradient-160);}.cls-123{fill:url(#linear-gradient-159);}.cls-124{fill:url(#linear-gradient-167);}.cls-125{fill:url(#linear-gradient-162);}.cls-126{fill:url(#linear-gradient-165);}.cls-127{fill:url(#linear-gradient-154);}.cls-128{fill:url(#linear-gradient-152);}.cls-129{fill:url(#linear-gradient-157);}.cls-130{fill:url(#linear-gradient-155);}.cls-131{fill:url(#linear-gradient-151);}.cls-132{fill:url(#linear-gradient-153);}.cls-133{fill:url(#linear-gradient-150);}.cls-134{fill:url(#linear-gradient-156);}.cls-135{fill:url(#linear-gradient-239);}.cls-136{fill:url(#linear-gradient-233);}.cls-137{fill:url(#linear-gradient-234);}.cls-138{fill:url(#linear-gradient-209);}.cls-139{fill:url(#linear-gradient-236);}.cls-140{fill:url(#linear-gradient-235);}.cls-141{fill:url(#linear-gradient-219);}.cls-142{fill:url(#linear-gradient-213);}.cls-143{fill:url(#linear-gradient-211);}.cls-144{fill:url(#linear-gradient-214);}.cls-145{fill:url(#linear-gradient-237);}.cls-146{fill:url(#linear-gradient-238);}.cls-147{fill:url(#linear-gradient-231);}.cls-148{fill:url(#linear-gradient-232);}.cls-149{fill:url(#linear-gradient-215);}.cls-150{fill:url(#linear-gradient-212);}.cls-151{fill:url(#linear-gradient-208);}.cls-152{fill:url(#linear-gradient-207);}.cls-153{fill:url(#linear-gradient-205);}.cls-154{fill:url(#linear-gradient-201);}.cls-155{fill:url(#linear-gradient-203);}.cls-156{fill:url(#linear-gradient-204);}.cls-157{fill:url(#linear-gradient-206);}.cls-158{fill:url(#linear-gradient-200);}.cls-159{fill:url(#linear-gradient-202);}.cls-160{fill:url(#linear-gradient-210);}.cls-161{fill:url(#linear-gradient-216);}.cls-162{fill:url(#linear-gradient-222);}.cls-163{fill:url(#linear-gradient-220);}.cls-164{fill:url(#linear-gradient-221);}.cls-316{mask:url(#mask);}.cls-165,.cls-307{fill:#fff;}.cls-166,.cls-279{fill:#ed1c24;}.cls-167{fill:url(#linear-gradient);}.cls-317{filter:url(#luminosity-noclip);}.cls-168{fill:#ef4136;}.cls-169,.cls-278{fill:#6d6e71;}.cls-170{fill:#f15a29;}.cls-171{fill:url(#linear-gradient-38);}.cls-172{fill:url(#linear-gradient-33);}.cls-173{fill:url(#linear-gradient-29);}.cls-174{fill:url(#linear-gradient-32);}.cls-175{fill:url(#linear-gradient-30);}.cls-176{fill:url(#linear-gradient-31);}.cls-177{fill:url(#linear-gradient-36);}.cls-178{fill:url(#linear-gradient-39);}.cls-179{fill:url(#linear-gradient-34);}.cls-180{fill:url(#linear-gradient-37);}.cls-181{fill:url(#linear-gradient-35);}.cls-182{fill:url(#linear-gradient-28);}.cls-183{fill:url(#linear-gradient-25);}.cls-184{fill:url(#linear-gradient-11);}.cls-185{fill:url(#linear-gradient-12);}.cls-186{fill:url(#linear-gradient-13);}.cls-187{fill:url(#linear-gradient-10);}.cls-188{fill:url(#linear-gradient-17);}.cls-189{fill:url(#linear-gradient-16);}.cls-190{fill:url(#linear-gradient-19);}.cls-191{fill:url(#linear-gradient-15);}.cls-192{fill:url(#linear-gradient-23);}.cls-193{fill:url(#linear-gradient-21);}.cls-194{fill:url(#linear-gradient-18);}.cls-195{fill:url(#linear-gradient-14);}.cls-196{fill:url(#linear-gradient-22);}.cls-197{fill:url(#linear-gradient-20);}.cls-198{fill:url(#linear-gradient-27);}.cls-199{fill:url(#linear-gradient-24);}.cls-200{fill:url(#linear-gradient-26);}.cls-201{fill:url(#linear-gradient-45);}.cls-202{fill:url(#linear-gradient-46);}.cls-203{fill:url(#linear-gradient-44);}.cls-204{fill:url(#linear-gradient-48);}.cls-205{fill:url(#linear-gradient-49);}.cls-206{fill:url(#linear-gradient-47);}.cls-207{fill:url(#linear-gradient-42);}.cls-208{fill:url(#linear-gradient-43);}.cls-209{fill:url(#linear-gradient-40);}.cls-210{fill:url(#linear-gradient-41);}.cls-211{fill:url(#linear-gradient-59);}.cls-212{fill:url(#linear-gradient-57);}.cls-213{fill:url(#linear-gradient-58);}.cls-214{fill:url(#linear-gradient-55);}.cls-215{fill:url(#linear-gradient-56);}.cls-216{fill:url(#linear-gradient-53);}.cls-217{fill:url(#linear-gradient-51);}.cls-218{fill:url(#linear-gradient-52);}.cls-219{fill:url(#linear-gradient-50);}.cls-220{fill:url(#linear-gradient-54);}.cls-221{fill:url(#linear-gradient-60);}.cls-222{fill:url(#linear-gradient-61);}.cls-223{fill:url(#linear-gradient-62);}.cls-224{fill:url(#linear-gradient-65);}.cls-225{fill:url(#linear-gradient-79);}.cls-226{fill:url(#linear-gradient-78);}.cls-227{fill:url(#linear-gradient-77);}.cls-228{fill:url(#linear-gradient-75);}.cls-229{fill:url(#linear-gradient-76);}.cls-230{fill:url(#linear-gradient-74);}.cls-231{fill:url(#linear-gradient-67);}.cls-232{fill:url(#linear-gradient-68);}.cls-233{fill:url(#linear-gradient-66);}.cls-234{fill:url(#linear-gradient-63);}.cls-235{fill:url(#linear-gradient-69);}.cls-236{fill:url(#linear-gradient-64);}.cls-237{fill:url(#linear-gradient-71);}.cls-238{fill:url(#linear-gradient-72);}.cls-239{fill:url(#linear-gradient-70);}.cls-240{fill:url(#linear-gradient-73);}.cls-241{fill:url(#linear-gradient-84);}.cls-242{fill:url(#linear-gradient-85);}.cls-243{fill:url(#linear-gradient-82);}.cls-244{fill:url(#linear-gradient-83);}.cls-245{fill:url(#linear-gradient-89);}.cls-246{fill:url(#linear-gradient-88);}.cls-247{fill:url(#linear-gradient-86);}.cls-248{fill:url(#linear-gradient-87);}.cls-249{fill:url(#linear-gradient-80);}.cls-250{fill:url(#linear-gradient-81);}.cls-251{fill:url(#linear-gradient-98);}.cls-252{fill:url(#linear-gradient-91);}.cls-253{fill:url(#linear-gradient-92);}.cls-254{fill:url(#linear-gradient-93);}.cls-255{fill:url(#linear-gradient-90);}.cls-256{fill:url(#linear-gradient-96);}.cls-257{fill:url(#linear-gradient-97);}.cls-258{fill:url(#linear-gradient-94);}.cls-259{fill:url(#linear-gradient-95);}.cls-260{fill:url(#linear-gradient-99);}.cls-261,.cls-274,.cls-284{fill:#000;}.cls-262{fill:#3c2415;}.cls-263{fill:#f1f2f2;}.cls-264{fill:#58595b;}.cls-265,.cls-280{fill:#bcbec0;}.cls-266,.cls-275{fill:#808285;}.cls-267{fill:url(#New_Gradient_Swatch_3-12);}.cls-268{fill:url(#New_Gradient_Swatch_3-11);}.cls-269{fill:url(#New_Gradient_Swatch_3-10);}.cls-270{fill:url(#New_Gradient_Swatch_3-14);}.cls-271{fill:url(#New_Gradient_Swatch_3-16);}.cls-272{fill:url(#New_Gradient_Swatch_3-13);}.cls-273{fill:url(#New_Gradient_Swatch_3-15);}.cls-276,.cls-282{fill:#a7a9ac;}.cls-277{fill:url(#New_Gradient_Swatch_11_cop);}.cls-281{fill:#be1e2d;}.cls-283,.cls-303{fill:#e6e7e8;}.cls-284{opacity:.5;}.cls-285{fill:url(#linear-gradient-4);}.cls-286{fill:url(#linear-gradient-2);}.cls-287{fill:url(#linear-gradient-3);}.cls-288{fill:url(#linear-gradient-8);}.cls-289{fill:url(#linear-gradient-9);}.cls-290{fill:url(#linear-gradient-7);}.cls-291{fill:url(#linear-gradient-6);}.cls-292{fill:url(#linear-gradient-218);}.cls-293{fill:url(#linear-gradient-217);}.cls-294{fill:url(#linear-gradient-223);}.cls-295{fill:url(#linear-gradient-229);}.cls-296{fill:url(#linear-gradient-228);}.cls-297{fill:url(#linear-gradient-227);}.cls-298{fill:url(#linear-gradient-224);}.cls-299{fill:url(#linear-gradient-225);}.cls-300{fill:url(#linear-gradient-226);}.cls-301{fill:url(#linear-gradient-249);}.cls-302{fill:url(#linear-gradient-230);}.cls-318{isolation:isolate;}.cls-304{fill:#c49a6c;}.cls-306{fill:#d1d3d4;}.cls-308{fill:#939598;}.cls-319{mask:url(#mask-3);}.cls-320{mask:url(#mask-2);}.cls-321{mask:url(#mask-5);}.cls-322{mask:url(#mask-4);}.cls-323{mask:url(#mask-1);}.cls-324{mask:url(#mask-7);}.cls-325{mask:url(#mask-6);}.cls-326{mask:url(#mask-8);}.cls-327{mask:url(#mask-9);}.cls-309{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 712.71,
    width: 1672.95,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 712.71,
    width: 1672.95,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-317"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1674,
    height: 88,
    transform: "translate(-.91 712.43)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 1954.48,
    y: 712.71,
    width: 1290.16,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 1954.48,
    y: 712.71,
    width: 1290.16,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1291,
    height: 88,
    transform: "translate(1954.09 712.43)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1645.81,
    y1: 577.92,
    x2: 1754.14,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1709.84,
    y1: 588,
    x2: 1754.14,
    y2: 588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#322f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 567.85,
    y2: 567.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1764.72,
    y1: 577.92,
    x2: 2005.08,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1764.72,
    y1: 577.86,
    x2: 2004.71,
    y2: 577.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -4968.14,
    y1: -3423.33,
    x2: -4968.14,
    y2: -3438.78,
    gradientTransform: "translate(6617.2 4026.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#434345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4d4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c5d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#737376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8f9194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1649.31,
    y1: 543.33,
    x2: 1692.2,
    y2: 543.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#aeafb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1c3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#cdcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1647.02,
    y1: 597.44,
    x2: 1647.02,
    y2: 594.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 594.07,
    y2: 590.75,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1647.78,
    y1: 567.03,
    x2: 1647.78,
    y2: 542.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1647.02,
    y1: 592.1,
    x2: 1647.02,
    y2: 587.77,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1612.48,
    y1: 577.1,
    x2: 1657.51,
    y2: 577.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1662,
    y1: 579.8,
    x2: 1682.55,
    y2: 579.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#67686a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9d9e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2001.07,
    y1: 573.03,
    x2: 2306.1,
    y2: 573.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#302f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2032.38,
    y1: 540.83,
    x2: 2032.38,
    y2: 510.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3f3e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#393739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e2c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2007.14,
    x2: 2007.14,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2040.36,
    x2: 2040.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2267.19,
    x2: 2267.19,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2275.16,
    x2: 2275.16,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2300.25,
    x2: 2300.25,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 2178.87,
    y1: 713.67,
    x2: 2178.87,
    y2: 526.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 2178.87,
    y1: 543.79,
    x2: 2178.87,
    y2: 702.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2178.87,
    y1: 678.45,
    x2: 2178.87,
    y2: 563.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2178.84,
    y1: 569.83,
    x2: 2178.84,
    y2: 670.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2178.87,
    y1: 638.92,
    x2: 2178.87,
    y2: 601.67,
    gradientTransform: "translate(403.31 -786.59) rotate(22.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2178.87,
    y1: 634.04,
    x2: 2178.87,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2273.44,
    y1: 3670.5,
    x2: 2273.44,
    y2: 3491.81,
    gradientTransform: "translate(-1023.49 2842.81) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2295.36,
    y1: 3488.83,
    x2: 2295.36,
    y2: 3673.3,
    gradientTransform: "translate(4944.55 4220.14) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4941.97 4217.56) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 3488.84,
    y2: 3673.3,
    gradientTransform: "translate(4938.79 4214.38) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4934.96 4210.55) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4930.46 4206.05) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4925.42 4201.01) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4919.84 4195.43) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 3488.84,
    y2: 3673.3,
    gradientTransform: "translate(4913.79 4189.38) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4907.12 4182.71) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 3488.84,
    y2: 3673.3,
    gradientTransform: "translate(4900.19 4175.78) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 3488.84,
    y2: 3673.3,
    gradientTransform: "translate(4892.75 4168.35) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4885.1 4160.69) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4877.09 4152.68) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4868.97 4144.56) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(4860.75 4136.34) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(170.55 -2941.93)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(173.13 -2944.51)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 3488.83,
    y2: 3673.31,
    gradientTransform: "translate(176.31 -2947.69)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(180.13 -2951.52)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(184.63 -2956.02)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(189.68 -2961.06)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 3488.83,
    y2: 3673.31,
    gradientTransform: "translate(195.26 -2966.64)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(201.31 -2972.69)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(207.98 -2979.36)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(214.91 -2986.29)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(222.34 -2993.73)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(230 -3001.38)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(238.01 -3009.39)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 3488.83,
    y2: 3673.31,
    gradientTransform: "translate(246.13 -3017.51)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 3488.83,
    y2: 3673.3,
    gradientTransform: "translate(254.35 -3025.73)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 2295.36,
    y1: 3488.83,
    x2: 2295.36,
    y2: 3673.31,
    gradientTransform: "translate(262.19 -3033.58)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 2251.52,
    x2: 2251.52,
    gradientTransform: "translate(4900.71 4263.97) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4898.13 4261.39) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 2251.52,
    y1: 3488.84,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4894.95 4258.21) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4891.13 4254.39) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4886.63 4249.89) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4881.59 4244.85) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4876 4239.26) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 2251.52,
    y1: 3488.84,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4869.95 4233.21) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4863.28 4226.54) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 2251.52,
    y1: 3488.84,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4856.35 4219.61) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 2251.52,
    y1: 3488.84,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4848.92 4212.18) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4841.27 4204.53) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4833.25 4196.51) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4825.13 4188.39) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(4816.91 4180.17) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(214.39 -2898.1)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(216.96 -2900.68)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.31,
    gradientTransform: "translate(220.14 -2903.86)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(223.97 -2907.68)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(228.47 -2912.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(233.51 -2917.22)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.31,
    gradientTransform: "translate(239.09 -2922.81)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(245.14 -2928.86)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(251.82 -2935.53)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(258.74 -2942.46)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(266.18 -2949.89)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(273.83 -2957.54)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(281.85 -2965.56)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.31,
    gradientTransform: "translate(289.96 -2973.68)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.3,
    gradientTransform: "translate(298.19 -2981.9)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 2251.52,
    y1: 3488.83,
    x2: 2251.52,
    y2: 3673.31,
    gradientTransform: "translate(306.03 -2989.74)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 2273.44,
    y1: 3490.33,
    x2: 2273.44,
    y2: 3673.8,
    gradientTransform: "translate(284.11 -3011.66)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 3069.31,
    y1: 604.79,
    x2: 3069.31,
    y2: 541.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#353436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#171617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 2840.38,
    x2: 2840.38,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 867.37,
    y1: 572.07,
    x2: 867.37,
    y2: 604.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 2238.55,
    y1: 2623.34,
    x2: 2238.55,
    y2: 2444.66,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 2260.47,
    y1: 2441.66,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3862.51 3207.86) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3859.93 3205.29) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3856.75 3202.11) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3852.92 3198.28) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3848.42 3193.78) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3843.38 3188.74) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3837.8 3183.15) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3831.75 3177.1) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3825.08 3170.43) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3818.15 3163.5) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3810.71 3156.07) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3803.06 3148.42) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3795.05 3140.4) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3786.93 3132.28) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(3778.71 3124.06) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-841.72 -1859.89)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.16,
    gradientTransform: "translate(-839.15 -1862.47)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-835.97 -1865.65)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-832.14 -1869.48)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-827.64 -1873.98)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-822.6 -1879.02)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-817.01 -1884.6)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-810.96 -1890.65)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-804.29 -1897.32)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-797.37 -1904.25)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-789.93 -1911.68)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.14,
    gradientTransform: "translate(-782.28 -1919.34)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 2260.47,
    y1: 2441.68,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-774.26 -1927.35)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-766.15 -1935.47)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-757.92 -1943.69)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 2260.47,
    y1: 2441.67,
    x2: 2260.47,
    y2: 2626.15,
    gradientTransform: "translate(-750.08 -1951.54)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 2216.64,
    y1: 2441.66,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3818.67 3251.7) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3816.09 3249.12) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3812.91 3245.94) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3809.09 3242.11) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3804.59 3237.61) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3799.55 3232.57) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3793.96 3226.99) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3787.91 3220.94) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3781.24 3214.27) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3774.31 3207.34) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3766.88 3199.91) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3759.23 3192.25) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3751.21 3184.24) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3743.09 3176.12) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(3734.87 3167.9) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-797.89 -1816.06)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.16,
    gradientTransform: "translate(-795.31 -1818.64)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-792.13 -1821.82)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-788.3 -1825.64)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-783.81 -1830.14)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-778.76 -1835.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-773.18 -1840.77)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-767.13 -1846.82)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-760.46 -1853.49)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-753.53 -1860.42)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-746.1 -1867.85)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.14,
    gradientTransform: "translate(-738.44 -1875.5)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 2216.64,
    y1: 2441.68,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-730.43 -1883.52)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-722.31 -1891.64)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-714.09 -1899.86)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 2216.64,
    y1: 2441.67,
    x2: 2216.64,
    y2: 2626.15,
    gradientTransform: "translate(-706.25 -1907.7)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 2238.55,
    y1: 2443.17,
    x2: 2238.55,
    y2: 2626.64,
    gradientTransform: "translate(-728.16 -1929.62)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 838.5,
    y1: 572.98,
    x2: 838.5,
    y2: 558.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 898.8,
    y1: 554.03,
    x2: 898.8,
    y2: 478.04,
    xlinkHref: "#linear-gradient-155"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 500.92,
    y1: 477.74,
    x2: 500.92,
    y2: 589.57,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1315.64,
    y1: 477.75,
    x2: 1315.64,
    y2: 586.63,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 1472.35,
    y1: 477.75,
    x2: 1472.35,
    y2: 586.63,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 821.19,
    y1: 477.75,
    x2: 821.19,
    y2: 586.63,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 977.9,
    y1: 477.75,
    x2: 977.9,
    y2: 586.63,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 414.15,
    y1: 565.29,
    x2: 414.15,
    y2: 483.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 455.36,
    y1: 3179.66,
    x2: 455.36,
    y2: 3098.09,
    gradientTransform: "translate(885.81 3688.91) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 315.17,
    y1: 3232.63,
    x2: 315.17,
    y2: 3300.46,
    gradientTransform: "translate(-139.51 3766.74) rotate(-164.48)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 315.17,
    y1: 3292.68,
    x2: 315.17,
    y2: 3239.6,
    gradientTransform: "translate(745.62 3801.45) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 315.17,
    y1: 3245.35,
    x2: 315.17,
    y2: 3287.33,
    gradientTransform: "translate(745.62 3801.45) rotate(-180)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 315.17,
    y1: 3282.51,
    x2: 315.17,
    y2: 3249.67,
    gradientTransform: "translate(745.62 3801.45) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 261.18,
    x2: 261.18,
    y2: 526.46,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 261.18,
    x2: 261.18,
    y2: 702.56,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 261.18,
    y1: 570.62,
    x2: 261.18,
    y2: 670.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 261.18,
    y1: 650.34,
    x2: 261.18,
    y2: 590.15,
    gradientTransform: "translate(832.39 264.19) rotate(80.87)",
    xlinkHref: "#linear-gradient-163"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 261.18,
    x2: 261.18,
    y2: 563.49,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 261.18,
    y1: 604.09,
    x2: 261.18,
    y2: 638.57,
    gradientTransform: "translate(515.26 -2.94) rotate(45)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 261.18,
    y1: 634.15,
    x2: 261.18,
    y2: 607.3,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 1146.97,
    y1: 546.43,
    x2: 1146.97,
    y2: 552.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    y1: 552.3,
    y2: 558,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 1146.97,
    y1: 558.16,
    x2: 1146.97,
    y2: 563.61,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    y1: 563.92,
    y2: 569.25,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 1146.97,
    y1: 569.35,
    x2: 1146.97,
    y2: 575.12,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    y1: 575.33,
    y2: 581.32,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    y1: 581.63,
    y2: 586.63,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    y1: 586.85,
    y2: 592.06,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    y1: 593.04,
    y2: 598.15,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 1146.97,
    y1: 598.91,
    x2: 1146.97,
    y2: 604.02,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    y1: 604.56,
    y2: 610.45,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 1146.97,
    y1: 610.86,
    x2: 1146.97,
    y2: 615.75,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 1127.03,
    y1: 546.38,
    x2: 1127.03,
    y2: 622.59,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 1166.9,
    y1: 546.38,
    x2: 1166.9,
    y2: 622.59,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 1028.47,
    x2: 1028.47,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1028.47,
    x2: 1028.47,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 1028.47,
    x2: 1028.47,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 1028.44,
    x2: 1028.44,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 1028.47,
    x2: 1028.47,
    gradientTransform: "translate(739.99 -545.5) rotate(45)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 1028.47,
    y1: 634.04,
    x2: 1028.47,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 1265.17,
    x2: 1265.17,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1265.17,
    x2: 1265.17,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 1265.17,
    x2: 1265.17,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 1265.13,
    x2: 1265.13,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 1265.17,
    x2: 1265.17,
    gradientTransform: "translate(333.76 -436.93) rotate(22.5)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 1265.17,
    y1: 634.04,
    x2: 1265.17,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 2955.12,
    x2: 2955.12,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 2955.12,
    y1: 552.3,
    x2: 2955.12,
    y2: 558,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 2955.12,
    y1: 558.16,
    x2: 2955.12,
    y2: 563.61,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 2955.12,
    y1: 563.92,
    x2: 2955.12,
    y2: 569.25,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 2955.12,
    y1: 569.35,
    x2: 2955.12,
    y2: 575.12,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 2955.12,
    y1: 575.33,
    x2: 2955.12,
    y2: 581.32,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 2955.12,
    y1: 581.63,
    x2: 2955.12,
    y2: 586.63,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 2955.12,
    y1: 586.85,
    x2: 2955.12,
    y2: 592.06,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 2955.12,
    y1: 593.04,
    x2: 2955.12,
    y2: 598.15,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 2955.12,
    y1: 598.91,
    x2: 2955.12,
    y2: 604.02,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 2955.12,
    y1: 604.56,
    x2: 2955.12,
    y2: 610.45,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 2955.12,
    y1: 610.86,
    x2: 2955.12,
    y2: 615.75,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 2935.18,
    y1: 546.38,
    x2: 2935.18,
    y2: 622.59,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 2975.05,
    y1: 546.38,
    x2: 2975.05,
    y2: 622.59,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 2836.62,
    x2: 2836.62,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 2836.62,
    x2: 2836.62,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 2836.62,
    x2: 2836.62,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 2836.59,
    x2: 2836.59,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 2836.62,
    x2: 2836.62,
    gradientTransform: "translate(453.38 -1038.29) rotate(22.5)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 2836.62,
    y1: 634.04,
    x2: 2836.62,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-6",
    x1: 3073.31,
    x2: 3073.31,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 3073.31,
    x2: 3073.31,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 3073.31,
    x2: 3073.31,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 3073.28,
    x2: 3073.28,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 3073.31,
    x2: 3073.31,
    gradientTransform: "translate(2971.11 -2513.16) rotate(76.72)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 3073.31,
    y1: 634.04,
    x2: 3073.31,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 2593.04,
    y1: 532.98,
    x2: 2593.04,
    y2: 621.86,
    gradientTransform: "translate(-1972.8 1153.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 2517.59,
    y1: 608.26,
    x2: 2517.59,
    y2: 628.5,
    gradientTransform: "translate(-1821.91 1236.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 2593.04,
    x2: 2593.04,
    gradientTransform: "translate(-1972.8 1236.47) scale(1 -1)",
    xlinkHref: "#linear-gradient-213"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 2668.48,
    x2: 2668.48,
    gradientTransform: "translate(-2123.69 1236.47) scale(1 -1)",
    xlinkHref: "#linear-gradient-213"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 2621.46,
    y1: 537.21,
    x2: 2641.47,
    y2: 537.21,
    gradientTransform: "translate(-2049.65 1074.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 156.37,
    y1: 369.71,
    x2: 156.37,
    y2: 257.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 303.58,
    y1: 369.71,
    x2: 303.58,
    y2: 257.87,
    xlinkHref: "#linear-gradient-217"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1618.48,
    y1: 493.49,
    x2: 1618.48,
    y2: 540.35,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-13",
    x1: 1617.86,
    y1: 494.02,
    x2: 1617.86,
    y2: 634.38,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 2363.58,
    y1: 1091.19,
    x2: 2363.58,
    y2: 1109.63,
    gradientTransform: "translate(-724.15 -572.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 1639.43,
    y1: 496.02,
    x2: 1639.43,
    y2: 516.02,
    gradientTransform: "translate(3278.86 1011.76) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-14",
    x1: 3219.52,
    y1: 515.13,
    x2: 3219.52,
    y2: 561.99,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-15",
    x1: 3230.38,
    y1: 600.45,
    x2: 3230.38,
    y2: 617.46,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-16",
    x1: 3218.91,
    y1: 480.76,
    x2: 3218.91,
    y2: 634.21,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 762.54,
    y1: 1069.54,
    x2: 762.54,
    y2: 1087.98,
    gradientTransform: "translate(4003.01 1628.78) rotate(-180)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 3240.47,
    y1: 517.67,
    x2: 3240.47,
    y2: 537.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 1363.01,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 1363.01,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 1363.01,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 1372.02,
    y1: 541.26,
    x2: 1372.02,
    y2: 486.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 1363.01,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-319"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "1370.17 541.26 1363.01 541.26 1363.01 486.41 1381.03 486.41 1370.17 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 1372.02,
    y1: 541.26,
    x2: 1372.02,
    y2: 486.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a7a5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#767474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 913.01,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 913.01,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 913.01,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 2641.34,
    y1: 541.26,
    x2: 2641.34,
    y2: 486.41,
    gradientTransform: "translate(3563.36) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-223"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 913.01,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-315"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-321"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "923.87 541.26 931.02 541.26 931.02 486.41 913.01 486.41 923.87 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 2641.34,
    y1: 541.26,
    x2: 2641.34,
    y2: 486.41,
    gradientTransform: "translate(3563.36) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-224"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 3171.16,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 3171.16,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 3171.16,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 3180.17,
    x2: 3180.17,
    xlinkHref: "#linear-gradient-223"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 3171.16,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-312"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-324"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "3178.32 541.26 3171.16 541.26 3171.16 486.41 3189.18 486.41 3178.32 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 3180.17,
    x2: 3180.17,
    xlinkHref: "#linear-gradient-224"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 2721.15,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 2721.15,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 2721.15,
    y: -8758.43,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 833.2,
    x2: 833.2,
    gradientTransform: "translate(3563.36) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-223"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 2721.15,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-311"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-327"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "2732.01 541.26 2739.17 541.26 2739.17 486.41 2721.15 486.41 2732.01 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 833.2,
    x2: 833.2,
    gradientTransform: "translate(3563.36) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-224"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 211.65,
    y1: 213.83,
    x2: 211.65,
    y2: 520.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 109.02,
    y1: 560.37,
    x2: 109.02,
    y2: 525.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 95.53,
    y1: 619.73,
    x2: 95.53,
    y2: 627.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 31.18,
    y1: 520.68,
    x2: 31.18,
    y2: 628.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 315.85,
    y1: 369.71,
    x2: 315.85,
    y2: 257.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 315.84,
    y1: 358.94,
    x2: 315.84,
    y2: 268.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d4d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 1054.26,
    y1: 1.28,
    x2: 1054.26,
    y2: 480.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 2633.07,
    y1: 1.28,
    x2: 2633.07,
    y2: 480.92,
    xlinkHref: "#linear-gradient-236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 96.95,
    y1: 168.55,
    x2: 431.8,
    y2: 168.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 477.37,
    y1: 524.09,
    x2: 477.37,
    y2: 504.58,
    gradientTransform: "translate(358.29 1028.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 452.34,
    y1: 504.41,
    x2: 452.34,
    y2: 524.95,
    gradientTransform: "translate(408.35 1028.22) scale(1 -1)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: -121.25,
    y1: 524.09,
    x2: -121.25,
    y2: 504.58,
    gradientTransform: "translate(1555.53 1028.22) scale(1 -1)",
    xlinkHref: "#linear-gradient-239"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: -146.28,
    y1: 504.41,
    x2: -146.28,
    y2: 524.95,
    gradientTransform: "translate(1605.59 1028.22) scale(1 -1)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: -726.23,
    y1: 492.02,
    x2: -726.23,
    y2: 477.08,
    gradientTransform: "translate(2765.49 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-239"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: -745.41,
    y1: 476.94,
    x2: -745.41,
    y2: 492.69,
    gradientTransform: "translate(2803.84 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: -1310.46,
    y1: 492.02,
    x2: -1310.46,
    y2: 477.08,
    gradientTransform: "translate(3933.94 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-239"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: -1329.63,
    y1: 476.94,
    x2: -1329.63,
    y2: 492.69,
    gradientTransform: "translate(3972.29 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: -1894.69,
    y1: 492.02,
    x2: -1894.69,
    y2: 477.08,
    gradientTransform: "translate(5102.4 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-239"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: -1913.86,
    y1: 476.94,
    x2: -1913.86,
    y2: 492.69,
    gradientTransform: "translate(5140.74 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 227.39,
    y1: 432.06,
    x2: 227.39,
    y2: 415.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 207.85,
    y1: 420.47,
    x2: 207.85,
    y2: 427.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 245.43,
    x2: 245.43,
    xlinkHref: "#linear-gradient-250"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 226.64,
    y1: 421.43,
    x2: 226.64,
    y2: 426.56,
    xlinkHref: "#linear-gradient-217"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 83.55,
    y1: 500.52,
    x2: 83.55,
    y2: 511.71,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 7.62,
    y1: 356.93,
    x2: 18.41,
    y2: 388.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 12.87,
    y1: 261.24,
    x2: 12.87,
    y2: 352.51,
    xlinkHref: "#linear-gradient-254"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-316"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-310",
    width: 1674,
    height: 88,
    transform: "translate(-.91 712.43)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-323"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-310",
    width: 1291,
    height: 88,
    transform: "translate(1954.09 712.43)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 1650.03,
    y: 555.99,
    width: 4.33,
    height: 32.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1886.21,579.92h-83.13c-14.42,0-25.79-9.14-40.18-20.7-25.51-20.51-60.45-48.59-139.14-48.59v-4c80.09,0,115.66,28.59,141.64,49.47,13.78,11.07,24.66,19.82,37.68,19.82h83.13c20.8,0,34.75-3.95,42.64-12.09,9.74-10.05,9.28-25.19,8.79-41.21-.69-22.34-1.4-45.44,27.36-53.99,13.29-3.95,22.27,2.58,30.19,8.34,5.89,4.29,11.46,8.34,18.41,8.34h35.15v4h-35.15c-8.25,0-14.61-4.63-20.76-9.1-7.87-5.73-15.3-11.13-26.7-7.75-25.8,7.67-25.17,28.25-24.5,50.04.5,16.15,1.01,32.86-9.91,44.12-8.68,8.95-23.56,13.3-45.51,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1900.64,580.79h-97.56c-14.33,0-25.67-8.17-40.03-18.52-25.54-18.4-60.51-43.61-139.28-43.61v-3.78c80,0,115.54,25.62,141.49,44.32,13.81,9.95,24.71,17.81,37.82,17.81h97.56c21.47,0,34.16-3.15,38.79-9.64,4.62-6.48,1.3-16.14-2.55-27.33-6.7-19.46-15.04-43.69,21.43-58.26,14.41-5.76,23.27-2.3,32.64,1.36,6.5,2.54,13.22,5.17,22.64,5.17h35.15v3.78h-35.15c-10.13,0-17.51-2.88-24.02-5.43-9.03-3.53-16.83-6.58-29.86-1.37-33.12,13.23-26.07,33.71-19.25,53.51,4.02,11.67,7.81,22.68,2.05,30.75-5.46,7.66-18.77,11.22-41.87,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2027.99,589.8h-319.4v-23.76h319.4c6.56,0,11.88,5.32,11.88,11.88h0c0,6.56-5.32,11.88-11.88,11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1728.73,599.91h-22.58c-10.81,0-14.63-9.85-14.63-21.99h0c0-12.15,3.82-21.99,14.63-21.99h22.58c10.81,0,42.16,9.85,42.16,21.99h0c0,12.15-31.34,21.99-42.16,21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1754.14,581.93h-104.33c-2.21,0-4-1.79-4-4h0c0-2.21,1.79-4,4-4h104.33v8.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-286",
    x: 1709.84,
    y: 586.19,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 1709.84,
    y: 566.04,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1735.46,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1735.46,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1745.21,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1745.21,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1696.21,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1696.21,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1705.95,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1705.95,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1709.84,
    y: 555.93,
    width: 7.99,
    height: 43.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1841.05,560.88c0-3.66-2.96-6.62-6.62-6.62s-6.62,2.96-6.62,6.62v21.31h13.24v-21.31ZM1831.43,560.25c0-1.65,1.34-3,3-3s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1764.72,
    y: 566.04,
    width: 240.36,
    height: 23.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 1764.72,
    y: 569.79,
    width: 240.36,
    height: 16.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1992.32,518.83l-156.87,42.53c-.74.2-1.51-.24-1.71-.98h0c-.2-.74.24-1.51.98-1.71l156.87-42.53c.74-.2,1.51.24,1.71.98h0c.2.74-.24,1.51-.98,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1871.73,556.11h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1871.02,554.46h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1870.68,552.23h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1874.08,555.48h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1873.36,553.82h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1873.02,551.59h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1876.42,554.84h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1875.7,553.19h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1875.36,550.96h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1878.76,554.21h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1878.04,552.55h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1877.7,550.32h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1881.1,553.58h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1880.38,551.92h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1880.04,549.69h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1883.44,552.94h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1882.72,551.28h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1882.38,549.05h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1885.78,552.31h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1885.06,550.65h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1884.73,548.42h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1888.12,551.67h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1887.4,550.01h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1887.07,547.78h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1890.46,551.04h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1889.74,549.38h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1889.41,547.15h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1892.8,550.4h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1892.08,548.74h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1891.75,546.51h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1895.14,549.77h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1894.42,548.11h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1894.09,545.88h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1897.48,549.13h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1896.77,547.47h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1896.43,545.25h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1899.82,548.5h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1899.11,546.84h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1898.77,544.61h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1902.17,547.86h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1901.45,546.21h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1901.11,543.98h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1904.51,547.23h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1903.79,545.57h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1903.45,543.34h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1906.85,546.59h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1906.13,544.94h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1905.79,542.71h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1909.19,545.96h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1908.47,544.3h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1908.13,542.07h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1911.53,545.33h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1910.81,543.67h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1910.47,541.44h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1913.87,544.69h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1913.15,543.03h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1912.82,540.8h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1916.21,544.06h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1915.49,542.4h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1915.16,540.17h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1918.55,543.42h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1917.83,541.76h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1917.5,539.53h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1920.89,542.79h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1920.17,541.13h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1919.84,538.9h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1923.23,542.15h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1922.51,540.49h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1922.18,538.26h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1925.57,541.52h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1924.85,539.86h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1924.52,537.63h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1927.91,540.88h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1927.2,539.22h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1926.86,537h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1930.26,540.25h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1929.54,538.59h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1929.2,536.36h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1932.6,539.61h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1931.88,537.96h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1931.54,535.73h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1934.94,538.98h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1934.22,537.32h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1933.88,535.09h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1937.28,538.35h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1936.56,536.69h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1936.22,534.46h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1939.62,537.71h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1938.9,536.05h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1938.56,533.82h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1941.96,537.08h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1941.24,535.42h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1940.91,533.19h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1944.3,536.44h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1943.58,534.78h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1943.25,532.55h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1946.64,535.81h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1945.92,534.15h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1945.59,531.92h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1948.98,535.17h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1948.26,533.51h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1947.93,531.28h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1951.32,534.54h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1950.6,532.88h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1950.27,530.65h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1953.66,533.9h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1952.94,532.24h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1952.61,530.01h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1956,533.27h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1955.29,531.61h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1954.95,529.38h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1958.35,532.63h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1957.63,530.97h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1957.29,528.75h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-307",
    x: 1764.72,
    y: 569.65,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1893.44,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1929.99,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1966.54,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1783.78,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1820.33,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 1856.88,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1764.72,
    y: 569.65,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M1645.29,587.9h7.54c1.52,0,2.75,1.23,2.75,2.75v12.99h-13.04v-12.99c0-1.52,1.23-2.75,2.75-2.75Z",
    transform: "translate(3298.12 1191.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M1660.37,553.87h-9.98c-.74,0-1.33-.6-1.33-1.33s.6-1.33,1.33-1.33h9.98c2.92,0,5.73-.89,8.12-2.57l22.18-15.61c.6-.43,1.43-.28,1.86.32.42.6.28,1.43-.32,1.86l-22.18,15.61c-2.84,2-6.18,3.06-9.65,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M1657.89,597.46h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M1657.89,594.09h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M1641.81,542.25h11.94c2.41,0,4.36,1.95,4.36,4.36v20.57h-20.65v-20.57c0-2.41,1.95-4.36,4.36-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M1655.9,592.13h-17.76c-1.22,0-2.21-.99-2.21-2.21h0c0-1.22.99-2.21,2.21-2.21h17.76c1.22,0,2.21.99,2.21,2.21h0c0,1.22-.99,2.21-2.21,2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "1645.12 586.32 1645.12 567.5 1658.1 567.5 1658.1 564.56 1612.22 564.56 1612.22 589.63 1655.88 589.63 1655.88 586.32 1645.12 586.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1681.39,595.15l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02h0c0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1681.39,595.15l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-.62.24-1.26.45-1.89.64v25.24l17.87,6.98c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M1692.52,533.36c-.42-.6-1.25-.75-1.86-.32l-22.18,15.61c-2.39,1.68-5.2,2.57-8.12,2.57h-2.27v-4.6c0-2.41-1.95-4.36-4.36-4.36h-11.94c-2.41,0-4.36,1.95-4.36,4.36v17.96h-25.23v25.06h23.76c-.01.1-.06.19-.06.29,0,.28.06.55.16.8-.9.03-1.63.76-1.63,1.68s.76,1.69,1.69,1.69c-.93,0-1.69.76-1.69,1.69s.76,1.69,1.69,1.69h6.4v3.43c0,1.52,1.23,2.75,2.75,2.75h7.54c1.52,0,2.75-1.23,2.75-2.75v-3.43h2.31c.93,0,1.69-.76,1.69-1.69s-.76-1.69-1.69-1.69c.93,0,1.69-.76,1.69-1.69s-.73-1.65-1.63-1.68c.1-.25.16-.52.16-.8,0-1.22-.99-2.21-2.21-2.21h-.01v-1.4h-10.76v-18.81h12.98v-13.63h2.27c3.47,0,6.81-1.06,9.65-3.06l22.18-15.61c.6-.42.75-1.25.32-1.86ZM1676.24,568.32c.41-1.32,1.4-2.41,2.74-2.93l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02,0,1.22.75,2.32,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92l-2.82-1.1c-.16-.06-.29-.17-.44-.25-1.26-.69-2.09-1.99-2.09-3.46v-20.64c0-.48.07-.94.21-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1623.5,592.93h0c-1.1,0-2-.89-2-2v-27.67c0-1.1.89-2,2-2h0c1.1,0,2,.89,2,2v27.67c0,1.1-.89,2-2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2018.92,
    y: 592.71,
    width: 39.48,
    height: 6.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M2008.88,583.56c-2.44,2.61-2.3,6.72.31,9.16l8.71,8.13c2.61,2.44,6.72,2.3,9.16-.31,2.44-2.61,2.3-6.72-.31-9.16l-8.71-8.13c-2.61-2.44-6.72-2.3-9.16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M2026.51,600.02h0c-2.15,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.16-2.43-5.77-.28-8.08h0c2.16-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.16,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2015.98,585.67c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16s-1.41-3.34-.16-4.67c1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2015.48,586.2c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.12-1.04-.97-1.1-2.6-.13-3.64.97-1.04,2.6-1.1,3.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2024.47,593.6c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16-1.33-1.25-1.41-3.34-.16-4.67,1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2023.98,594.13c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.13-1.04-.97-1.1-2.6-.13-3.64s2.6-1.1,3.64-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M2026.51,600.02h0c-2.15,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.16-2.43-5.77-.28-8.08h0c2.16-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.16,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2303.68,591.07l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2063.49,
    y: 473.89,
    width: 215.96,
    height: 75.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M2001.07,541.26v5.12l20.43,18.32v17.28l23.52,22.8h12.88l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h209.96l24.45-21.05v-29.01h-305.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M2004.85,538.26v5.12l20.43,18.32v17.28l23.52,22.8h6.42l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h208.68l24.45-21.05v-29.01h-297.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2036.34,572.99c2.73,0,4.94,2.21,4.94,4.94s-2.21,4.94-4.94,4.94-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2036.34,574.07c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2053.71,572.99c2.73,0,4.94,2.21,4.94,4.94s-2.21,4.94-4.94,4.94-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2053.71,574.07c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1993.73,510.45c-3.66,0-6.62,2.96-6.62,6.62s2.96,6.62,6.62,6.62h21.31v-13.24h-21.31ZM1993.11,520.07c-1.65,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2001.07,
    y: 504.64,
    width: 305.03,
    height: 41.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2001.07,
    y: 510.19,
    width: 305.03,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2030.1,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 2004.85,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 2038.07,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 2264.9,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 2272.87,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 2297.97,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 2179.12,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2178.88,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2178.88,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2271.17,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2178.88,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2178.88,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2178.88,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M2178.88,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2178.88,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M2178.88,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2178.88,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M2178.84,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2146.08,587.95c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2138.03,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2157.34,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2178.71,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2178.97,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2200.34,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2211.61,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2219.65,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M2228.88,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2153.71,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2178.71,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2214.88,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M2143.67,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.97-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2178.71,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M2178.84,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2146.08,587.95c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2138.03,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2157.34,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2178.71,574.33c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2178.97,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2200.34,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2211.61,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2219.65,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2181.35 641.63 2177.18 641.63 2175.09 645.24 2177.18 648.85 2181.35 648.85 2183.44 645.24 2181.35 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 2179.26,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2195.56 633.69 2192.61 636.64 2193.69 640.67 2197.72 641.75 2200.67 638.8 2199.59 634.77 2195.56 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2198.09,636.27c.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2200 618.03 2200 622.2 2203.61 624.29 2207.22 622.2 2207.22 618.03 2203.61 615.94 2200 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2203.61,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2192.06 603.82 2195.01 606.77 2199.04 605.69 2200.12 601.66 2197.17 598.71 2193.14 599.79 2192.06 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2194.64,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2176.4 599.38 2180.57 599.38 2182.66 595.77 2180.57 592.16 2176.4 592.16 2174.31 595.77 2176.4 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2176.44,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2162.19 607.32 2165.14 604.37 2164.06 600.34 2160.03 599.26 2157.08 602.21 2158.16 606.24 2162.19 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2159.66,604.74c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2157.75 622.98 2157.75 618.81 2154.14 616.72 2150.53 618.81 2150.53 622.98 2154.14 625.07 2157.75 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2154.14,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2165.69 637.19 2162.74 634.24 2158.71 635.32 2157.63 639.35 2160.58 642.3 2164.61 641.22 2165.69 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2163.11,639.72c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-192",
    cx: 2178.87,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-71.6 881.05) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 2178.87,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M2288.66,582.05c-3.27,1.44-4.77,5.27-3.33,8.54l4.79,10.91c1.44,3.27,5.27,4.77,8.54,3.33,3.27-1.44,4.77-5.27,3.33-8.54l-4.79-10.91c-1.44-3.27-5.27-4.77-8.54-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M2298.35,604.13h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2294.35,586.79c.73,1.67-.03,3.62-1.7,4.35-1.67.73-3.62-.03-4.35-1.7-.73-1.67.03-3.62,1.7-4.35s3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2293.68,587.08c.57,1.3-.02,2.82-1.32,3.4-1.3.57-2.82-.02-3.4-1.32-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2299.02,597.43c.73,1.67-.03,3.62-1.7,4.35s-3.62-.03-4.35-1.7.03-3.62,1.7-4.35c1.67-.73,3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2298.36,597.72c.57,1.3-.02,2.82-1.32,3.4s-2.82-.02-3.4-1.32c-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M2298.35,604.13h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M2068.36,581.76c-3.35-1.23-7.09.49-8.32,3.85l-4.11,11.18c-1.23,3.35.49,7.09,3.85,8.32,3.35,1.23,7.09-.49,8.32-3.84l4.11-11.18c1.23-3.35-.49-7.09-3.85-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M2060.03,604.4h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2069.17,589.12c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24.63-1.71,2.53-2.59,4.24-1.96,1.71.63,2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2068.49,588.87c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53,1.34.49,2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2065.16,600.03c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24s2.53-2.59,4.24-1.96c1.71.63,2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2064.48,599.78c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53,1.34.49,2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M2060.03,604.4h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M2471.54,540l-6.29,4.47v49.81l6.29,4.47c2.36,1.67,5.28,2.59,8.3,2.59h155.42c3.01,0,5.94-.91,8.3-2.59l6.29-4.47h0v-49.81h0l-6.29-4.47c-2.35-1.67-5.28-2.59-8.3-2.59h-155.42c-3.02,0-5.94.91-8.3,2.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2532.64,
    y: 477.08,
    width: 49.81,
    height: 184.59,
    transform: "translate(1988.17 3126.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 2646.2,
    y: 546.8,
    width: 5.98,
    height: 1.31,
    transform: "translate(3196.65 -2101.73) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 2643.63,
    y: 546.61,
    width: 5.98,
    height: 1.71,
    transform: "translate(3194.07 -2099.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 2640.44,
    y: 546.48,
    width: 5.98,
    height: 1.96,
    transform: "translate(3190.89 -2095.97) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 2636.62,
    y: 546.27,
    width: 5.98,
    height: 2.38,
    transform: "translate(3187.07 -2092.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2632.12,
    y: 546.06,
    width: 5.98,
    height: 2.79,
    transform: "translate(3182.57 -2087.65) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2627.08,
    y: 545.93,
    width: 5.98,
    height: 3.05,
    transform: "translate(3177.53 -2082.61) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 2621.49,
    y: 545.73,
    width: 5.98,
    height: 3.46,
    transform: "translate(3171.94 -2077.02) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2615.44,
    y: 545.62,
    width: 5.98,
    height: 3.67,
    transform: "translate(3165.89 -2070.97) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 2608.77,
    y: 545.52,
    width: 5.98,
    height: 3.88,
    transform: "translate(3159.22 -2064.3) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2601.84,
    y: 545.36,
    width: 5.98,
    height: 4.19,
    transform: "translate(3152.29 -2057.37) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 2594.41,
    y: 545.29,
    width: 5.98,
    height: 4.34,
    transform: "translate(3144.86 -2049.94) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2586.76,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(3137.21 -2042.29) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 2578.74,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(3129.19 -2034.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 2570.62,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(3121.07 -2026.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 2562.4,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(3112.85 -2017.93) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 2462.92,
    y: 546.8,
    width: 5.98,
    height: 1.31,
    transform: "translate(1918.45 3013.37) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 2465.49,
    y: 546.61,
    width: 5.98,
    height: 1.71,
    transform: "translate(1921.02 3015.94) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 2468.67,
    y: 546.48,
    width: 5.98,
    height: 1.97,
    transform: "translate(1924.2 3019.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 2472.5,
    y: 546.27,
    width: 5.98,
    height: 2.38,
    transform: "translate(1928.03 3022.95) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 2477,
    y: 546.06,
    width: 5.98,
    height: 2.79,
    transform: "translate(1932.53 3027.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 2482.04,
    y: 545.93,
    width: 5.98,
    height: 3.05,
    transform: "translate(1937.57 3032.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2487.63,
    y: 545.73,
    width: 5.98,
    height: 3.46,
    transform: "translate(1943.16 3038.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 2493.68,
    y: 545.62,
    width: 5.98,
    height: 3.67,
    transform: "translate(1949.21 3044.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 2500.35,
    y: 545.52,
    width: 5.98,
    height: 3.88,
    transform: "translate(1955.88 3050.79) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 2507.28,
    y: 545.36,
    width: 5.98,
    height: 4.19,
    transform: "translate(1962.81 3057.72) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 2514.71,
    y: 545.29,
    width: 5.98,
    height: 4.34,
    transform: "translate(1970.24 3065.16) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 2522.36,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(1977.89 3072.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 2530.38,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(1985.91 3080.83) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 2538.5,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(1994.03 3088.94) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 2546.72,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(2002.25 3097.17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 2554.56,
    y: 545.08,
    width: 5.98,
    height: 4.76,
    transform: "translate(2010.09 3105.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 2646.2,
    y: 590.64,
    width: 5.98,
    height: 1.31,
    transform: "translate(3240.49 -2057.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 2643.63,
    y: 590.44,
    width: 5.98,
    height: 1.71,
    transform: "translate(3237.91 -2055.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 2640.44,
    y: 590.31,
    width: 5.98,
    height: 1.96,
    transform: "translate(3234.73 -2052.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 2636.62,
    y: 590.1,
    width: 5.98,
    height: 2.38,
    transform: "translate(3230.9 -2048.31) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 2632.12,
    y: 589.9,
    width: 5.98,
    height: 2.79,
    transform: "translate(3226.4 -2043.81) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 2627.08,
    y: 589.77,
    width: 5.98,
    height: 3.05,
    transform: "translate(3221.36 -2038.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2621.49,
    y: 589.56,
    width: 5.98,
    height: 3.46,
    transform: "translate(3215.78 -2033.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 2615.44,
    y: 589.46,
    width: 5.98,
    height: 3.67,
    transform: "translate(3209.73 -2027.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 2608.77,
    y: 589.35,
    width: 5.98,
    height: 3.88,
    transform: "translate(3203.06 -2020.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 2601.84,
    y: 589.2,
    width: 5.98,
    height: 4.19,
    transform: "translate(3196.13 -2013.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 2594.41,
    y: 589.12,
    width: 5.98,
    height: 4.34,
    transform: "translate(3188.69 -2006.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 2586.76,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(3181.04 -1998.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 2578.74,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(3173.03 -1990.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 2570.62,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(3164.91 -1982.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 2562.4,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(3156.69 -1974.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2462.92,
    y: 590.64,
    width: 5.98,
    height: 1.31,
    transform: "translate(1874.61 3057.2) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2465.49,
    y: 590.44,
    width: 5.98,
    height: 1.71,
    transform: "translate(1877.19 3059.78) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 2468.67,
    y: 590.31,
    width: 5.98,
    height: 1.97,
    transform: "translate(1880.37 3062.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 2472.5,
    y: 590.1,
    width: 5.98,
    height: 2.38,
    transform: "translate(1884.2 3066.78) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 2477,
    y: 589.9,
    width: 5.98,
    height: 2.79,
    transform: "translate(1888.69 3071.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 2482.04,
    y: 589.77,
    width: 5.98,
    height: 3.05,
    transform: "translate(1893.74 3076.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 2487.63,
    y: 589.56,
    width: 5.98,
    height: 3.46,
    transform: "translate(1899.32 3081.91) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 2493.68,
    y: 589.46,
    width: 5.98,
    height: 3.67,
    transform: "translate(1905.37 3087.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 2500.35,
    y: 589.36,
    width: 5.98,
    height: 3.88,
    transform: "translate(1912.04 3094.63) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 2507.28,
    y: 589.2,
    width: 5.98,
    height: 4.19,
    transform: "translate(1918.97 3101.56) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2514.71,
    y: 589.12,
    width: 5.98,
    height: 4.34,
    transform: "translate(1926.4 3108.99) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 2522.36,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(1934.06 3116.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 2530.38,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(1942.07 3124.66) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 2538.5,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(1950.19 3132.78) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 2546.72,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(1958.41 3141) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 2554.56,
    y: 588.91,
    width: 5.98,
    height: 4.76,
    transform: "translate(1966.25 3148.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 2537.57,
    y: 477.08,
    width: 39.96,
    height: 184.59,
    transform: "translate(1988.17 3126.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2465.64,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2471.11,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2476.58,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2482.04,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2489.09,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2496.14,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2503.18,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2510.23,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2517.28,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2525.49,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2533.71,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2541.92,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2550.13,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2643.59,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2638.12,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2632.65,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2627.19,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98s.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2620.14,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2613.09,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2606.05,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2599,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2591.95,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2583.74,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2575.52,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2567.31,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2559.1,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2649.45,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2643.99,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2638.52,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2633.06,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2626.01,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2618.96,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2611.91,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2604.86,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2597.82,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2589.6,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2581.39,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2573.18,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2564.97,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2471.51,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2476.98,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2482.44,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2487.91,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2494.96,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2502,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2509.05,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2516.1,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2523.15,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2531.36,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2539.57,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2547.78,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2556,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2556.79,
    y: 477.08,
    width: 1.52,
    height: 184.59,
    transform: "translate(1988.17 3126.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2556.79,
    y: 494.83,
    width: 1.52,
    height: 184.59,
    transform: "translate(1970.43 3144.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2556.79,
    y: 459.33,
    width: 1.52,
    height: 184.59,
    transform: "translate(2005.92 3109.18) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 2465.25,
    y: 537.41,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "2927.01 541.26 2927.01 581.99 2950.53 604.79 2976.09 604.79 2986.08 591.32 3152.55 591.32 3162.54 604.79 3188.09 604.79 3211.61 581.99 3211.61 541.26 2927.01 541.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "2698.08 541.26 2698.08 581.99 2721.61 604.79 2747.16 604.79 2757.15 591.32 2923.62 591.32 2933.61 604.79 2959.16 604.79 2982.68 581.99 2982.68 541.26 2698.08 541.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3244.64 546.38 2439.62 546.38 2333.7 494.2 2021.5 494.2 2021.5 473.89 3244.64 473.89 3244.64 546.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2465.14,
    y: 490.87,
    width: 779.5,
    height: 55.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2465.14,
    y: 498.25,
    width: 779.5,
    height: 40.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M674.93,580.98c-66.22,0-92.91,9.07-112.4,15.7-10.84,3.68-18.68,6.34-30.09,6.34h-166.1c-18.02,0-45.37-41.1-58.37-67.01-1.55-3.08-5.3-4.33-8.38-2.78-3.08,1.55-4.33,5.3-2.78,8.38,3.79,7.56,37.98,73.9,69.54,73.9h166.1c13.48,0,23.04-3.25,34.11-7.01,18.66-6.34,44.23-15.03,108.38-15.03h942.93v-12.5h-942.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 776.79,
    y: 569.96,
    width: 181.17,
    height: 31.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M1424.39,574.88l-6.29,4.47v49.81l6.29,4.47c2.36,1.67,5.28,2.59,8.3,2.59h155.42c3.01,0,5.94-.91,8.3-2.59l6.29-4.47h0v-49.81h0l-6.29-4.47c-2.35-1.67-5.28-2.59-8.3-2.59h-155.42c-3.02,0-5.94.91-8.3,2.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 1485.48,
    y: 511.96,
    width: 49.81,
    height: 184.59,
    transform: "translate(906.13 2114.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 1599.04,
    y: 581.69,
    width: 5.98,
    height: 1.31,
    transform: "translate(2184.38 -1019.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 1596.47,
    y: 581.49,
    width: 5.98,
    height: 1.71,
    transform: "translate(2181.8 -1017.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 1593.29,
    y: 581.36,
    width: 5.98,
    height: 1.96,
    transform: "translate(2178.62 -1013.93) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 1589.46,
    y: 581.15,
    width: 5.98,
    height: 2.38,
    transform: "translate(2174.79 -1010.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 1584.96,
    y: 580.95,
    width: 5.98,
    height: 2.79,
    transform: "translate(2170.29 -1005.61) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 1579.92,
    y: 580.82,
    width: 5.98,
    height: 3.05,
    transform: "translate(2165.25 -1000.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 1574.34,
    y: 580.61,
    width: 5.98,
    height: 3.46,
    transform: "translate(2159.67 -994.98) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 1568.29,
    y: 580.51,
    width: 5.98,
    height: 3.67,
    transform: "translate(2153.62 -988.93) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1561.61,
    y: 580.4,
    width: 5.98,
    height: 3.88,
    transform: "translate(2146.95 -982.26) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1554.69,
    y: 580.25,
    width: 5.98,
    height: 4.19,
    transform: "translate(2140.02 -975.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1547.25,
    y: 580.17,
    width: 5.98,
    height: 4.34,
    transform: "translate(2132.58 -967.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1539.6,
    y: 580.03,
    width: 5.98,
    height: 4.63,
    transform: "translate(2124.93 -960.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1531.58,
    y: 580.03,
    width: 5.98,
    height: 4.63,
    transform: "translate(2116.92 -952.23) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1523.47,
    y: 579.92,
    width: 5.98,
    height: 4.83,
    transform: "translate(2108.8 -944.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1515.24,
    y: 579.92,
    width: 5.98,
    height: 4.83,
    transform: "translate(2100.58 -935.89) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1415.76,
    y: 581.69,
    width: 5.98,
    height: 1.31,
    transform: "translate(836.41 2001.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1418.34,
    y: 581.49,
    width: 5.98,
    height: 1.71,
    transform: "translate(838.98 2003.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1421.52,
    y: 581.36,
    width: 5.98,
    height: 1.96,
    transform: "translate(842.16 2006.85) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1425.34,
    y: 581.15,
    width: 5.98,
    height: 2.38,
    transform: "translate(845.99 2010.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1429.84,
    y: 580.95,
    width: 5.98,
    height: 2.79,
    transform: "translate(850.49 2015.17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1434.88,
    y: 580.82,
    width: 5.98,
    height: 3.05,
    transform: "translate(855.53 2020.21) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 1440.47,
    y: 580.61,
    width: 5.98,
    height: 3.46,
    transform: "translate(861.12 2025.8) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1446.52,
    y: 580.51,
    width: 5.98,
    height: 3.67,
    transform: "translate(867.17 2031.85) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1453.19,
    y: 580.4,
    width: 5.98,
    height: 3.88,
    transform: "translate(873.84 2038.52) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1460.12,
    y: 580.25,
    width: 5.98,
    height: 4.19,
    transform: "translate(880.76 2045.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1467.55,
    y: 580.17,
    width: 5.98,
    height: 4.34,
    transform: "translate(888.2 2052.88) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1475.2,
    y: 580.03,
    width: 5.98,
    height: 4.63,
    transform: "translate(895.85 2060.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1483.22,
    y: 580.03,
    width: 5.98,
    height: 4.63,
    transform: "translate(903.87 2068.55) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1491.34,
    y: 579.92,
    width: 5.98,
    height: 4.83,
    transform: "translate(911.98 2076.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1499.56,
    y: 579.92,
    width: 5.98,
    height: 4.83,
    transform: "translate(920.21 2084.89) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 1507.4,
    y: 579.96,
    width: 5.98,
    height: 4.76,
    transform: "translate(928.05 2092.73) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1599.04,
    y: 625.52,
    width: 5.98,
    height: 1.31,
    transform: "translate(2228.21 -975.86) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1596.47,
    y: 625.32,
    width: 5.98,
    height: 1.71,
    transform: "translate(2225.63 -973.28) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1593.29,
    y: 625.19,
    width: 5.98,
    height: 1.96,
    transform: "translate(2222.45 -970.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1589.46,
    y: 624.99,
    width: 5.98,
    height: 2.38,
    transform: "translate(2218.63 -966.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1584.96,
    y: 624.78,
    width: 5.98,
    height: 2.79,
    transform: "translate(2214.13 -961.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1579.92,
    y: 624.65,
    width: 5.98,
    height: 3.05,
    transform: "translate(2209.09 -956.73) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1574.34,
    y: 624.44,
    width: 5.98,
    height: 3.46,
    transform: "translate(2203.5 -951.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1568.29,
    y: 624.34,
    width: 5.98,
    height: 3.67,
    transform: "translate(2197.45 -945.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1561.62,
    y: 624.24,
    width: 5.98,
    height: 3.88,
    transform: "translate(2190.78 -938.43) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1554.69,
    y: 624.08,
    width: 5.98,
    height: 4.19,
    transform: "translate(2183.85 -931.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1547.25,
    y: 624.01,
    width: 5.98,
    height: 4.34,
    transform: "translate(2176.42 -924.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1539.6,
    y: 623.86,
    width: 5.98,
    height: 4.63,
    transform: "translate(2168.77 -916.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1531.58,
    y: 623.86,
    width: 5.98,
    height: 4.63,
    transform: "translate(2160.75 -908.4) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1523.47,
    y: 623.76,
    width: 5.98,
    height: 4.83,
    transform: "translate(2152.63 -900.28) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1515.24,
    y: 623.76,
    width: 5.98,
    height: 4.83,
    transform: "translate(2144.41 -892.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1415.76,
    y: 625.52,
    width: 5.98,
    height: 1.31,
    transform: "translate(792.57 2044.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1418.34,
    y: 625.32,
    width: 5.98,
    height: 1.71,
    transform: "translate(795.15 2047.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1421.52,
    y: 625.19,
    width: 5.98,
    height: 1.96,
    transform: "translate(798.33 2050.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1425.34,
    y: 624.99,
    width: 5.98,
    height: 2.38,
    transform: "translate(802.16 2054.51) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 1429.84,
    y: 624.78,
    width: 5.98,
    height: 2.79,
    transform: "translate(806.65 2059.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1434.88,
    y: 624.65,
    width: 5.98,
    height: 3.05,
    transform: "translate(811.7 2064.05) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1440.47,
    y: 624.45,
    width: 5.98,
    height: 3.46,
    transform: "translate(817.28 2069.63) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1446.52,
    y: 624.34,
    width: 5.98,
    height: 3.67,
    transform: "translate(823.33 2075.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1453.19,
    y: 624.24,
    width: 5.98,
    height: 3.88,
    transform: "translate(830 2082.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1460.12,
    y: 624.08,
    width: 5.98,
    height: 4.19,
    transform: "translate(836.93 2089.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1467.55,
    y: 624.01,
    width: 5.98,
    height: 4.34,
    transform: "translate(844.36 2096.72) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1475.2,
    y: 623.86,
    width: 5.98,
    height: 4.63,
    transform: "translate(852.02 2104.37) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 1483.22,
    y: 623.86,
    width: 5.98,
    height: 4.63,
    transform: "translate(860.03 2112.39) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1491.34,
    y: 623.76,
    width: 5.98,
    height: 4.83,
    transform: "translate(868.15 2120.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 1499.56,
    y: 623.76,
    width: 5.98,
    height: 4.83,
    transform: "translate(876.37 2128.73) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1507.4,
    y: 623.8,
    width: 5.98,
    height: 4.76,
    transform: "translate(884.21 2136.57) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1490.41,
    y: 511.96,
    width: 39.96,
    height: 184.59,
    transform: "translate(906.13 2114.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1418.49,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1423.95,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1429.42,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1434.88,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1441.93,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1448.98,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1456.03,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1463.07,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1470.12,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1478.34,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1486.55,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1494.76,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1502.97,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1596.43,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1590.96,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1585.5,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1580.03,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1572.98,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1565.94,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1558.89,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1551.84,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1544.79,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1536.58,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1528.37,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1520.15,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1511.94,612.05c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1602.3,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1596.83,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1591.36,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1585.9,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1578.85,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1571.8,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1564.75,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1557.71,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1550.66,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1542.45,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1534.23,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1526.02,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1517.81,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1424.35,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1429.82,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1435.28,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1440.75,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1447.8,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1454.85,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1461.89,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1468.94,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1475.99,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1484.2,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1492.41,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1500.63,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1508.84,596.47c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 1509.63,
    y: 511.96,
    width: 1.52,
    height: 184.59,
    transform: "translate(906.13 2114.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 1509.63,
    y: 529.71,
    width: 1.52,
    height: 184.59,
    transform: "translate(888.38 2132.4) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 1509.63,
    y: 494.22,
    width: 1.52,
    height: 184.59,
    transform: "translate(923.88 2096.9) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 1418.09,
    y: 572.29,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M317.49,607.84h-99.68c-19.41,0-38.4-3.9-54.92-11.27-12.7-5.67-27.33-8.66-42.31-8.66h-61.44v-19.3h61.44c19.4,0,38.39,3.9,54.91,11.27,12.7,5.67,27.33,8.67,42.31,8.67h99.68c12.07,0,24.18-2,35.02-5.78l19.12-6.66c14.08-4.91,29.77-7.5,45.38-7.5h1200.85v19.3H417.01c-12.07,0-24.17,2-35.02,5.78l-19.12,6.67c-14.07,4.91-29.77,7.5-45.38,7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 59.14,
    y: 528.21,
    width: 1558.72,
    height: 45.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 174.1,
    y: 473.89,
    width: 1449.41,
    height: 81.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 681.39,
    y: 606.4,
    width: 334.08,
    height: 13.18,
    transform: "translate(89.93 -108.3) rotate(7.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M72.32,420.31h301.54c13.6,0,24.64,11.04,24.64,24.64v100.14H72.32v-124.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M384.61,280.11h36.12v181.89c0,8.58-6.96,15.54-15.54,15.54h-20.58v-197.43h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 494.65,
    y: 478.3,
    width: 12.54,
    height: 111.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1309.37,
    y: 478.3,
    width: 12.54,
    height: 108.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1466.08,
    y: 478.3,
    width: 12.54,
    height: 108.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 814.92,
    y: 478.3,
    width: 12.54,
    height: 108.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 971.63,
    y: 478.3,
    width: 12.54,
    height: 108.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M429.94,522.33h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M414.66,552.21h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-123",
    cx: 430.45,
    cy: 535.43,
    r: 34.46,
    transform: "translate(-127.54 134.65) rotate(-15.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 430.45,
    cy: 535.43,
    r: 27.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 430.45,
    cy: 535.43,
    r: 21.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 430.45,
    cy: 535.43,
    r: 17.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M261.18,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM261.18,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M353.48,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM261.18,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M261.18,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM261.18,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M311.06,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 261.18,
    cy: 620.5,
    r: 31.07,
    transform: "translate(-392.9 779.94) rotate(-80.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M261.18,569.85c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM261.18,668.11c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M261.18,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM261.18,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M311.06,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M261.18,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM261.18,669.46c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-115",
    cx: 261.18,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-362.27 366.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "263.65 641.63 259.48 641.63 257.4 645.24 259.48 648.85 263.65 648.85 265.74 645.24 263.65 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M263.61,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "277.86 633.69 274.91 636.64 275.99 640.67 280.02 641.75 282.97 638.8 281.89 634.77 277.86 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M280.39,636.27c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.09,0-2.89s2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "282.3 618.03 282.3 622.2 285.91 624.29 289.53 622.2 289.53 618.03 285.91 615.94 282.3 618.03"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 285.91,
    cy: 620.12,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "274.36 603.82 277.31 606.77 281.34 605.69 282.42 601.66 279.47 598.71 275.44 599.79 274.36 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M276.95,601.29c.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "258.71 599.38 262.88 599.38 264.96 595.77 262.88 592.16 258.71 592.16 256.62 595.77 258.71 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M258.74,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "244.5 607.32 247.45 604.37 246.37 600.34 242.34 599.26 239.39 602.21 240.47 606.24 244.5 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M241.97,604.74c-.8-.8-.8-2.09,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "240.06 622.98 240.06 618.81 236.45 616.72 232.83 618.81 232.83 622.98 236.45 625.07 240.06 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M236.45,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "247.99 637.19 245.04 634.24 241.02 635.32 239.94 639.35 242.89 642.3 246.92 641.22 247.99 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M245.41,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89s2.09-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 261.18,
    cy: 620.5,
    r: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1165.87,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 1028.72,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1402.33,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 1265.18,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 1114.26,
    y: 546.32,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1106.35,
    y: 552.12,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1098.44,
    y: 557.92,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1090.53,
    y: 563.71,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1082.63,
    y: 569.51,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1074.72,
    y: 575.31,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1066.81,
    y: 581.11,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1058.91,
    y: 586.91,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1051,
    y: 592.7,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1043.09,
    y: 598.5,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1035.19,
    y: 604.3,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1027.28,
    y: 610.1,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1123.44,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1163.31,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1128.14,609.89l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1128.26,629.33c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1165.68,629.33c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4.54-6.31,6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 1028.72,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1028.47,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1028.47,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1120.77,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1028.47,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1028.47,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1028.47,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1028.47,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1028.47,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1028.47,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1028.47,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1028.44,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM995.67,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM987.63,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1006.94,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1028.31,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1028.57,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1049.94,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1061.21,653.12c-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1069.25,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M1078.48,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1003.31,595.59c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1028.31,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1064.47,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M993.27,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1028.31,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1028.44,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM995.67,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM987.63,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1006.94,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1028.31,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1028.57,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1049.94,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1061.21,653.12c-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1069.25,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1030.94 641.63 1026.77 641.63 1024.69 645.24 1026.77 648.85 1030.94 648.85 1033.03 645.24 1030.94 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1030.9,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1045.15 633.69 1042.2 636.64 1043.28 640.67 1047.31 641.75 1050.26 638.8 1049.18 634.77 1045.15 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1047.68,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1049.59 618.03 1049.59 622.2 1053.2 624.29 1056.82 622.2 1056.82 618.03 1053.2 615.94 1049.59 618.03"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 1053.2,
    cy: 620.12,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1041.65 603.82 1044.6 606.77 1048.63 605.69 1049.71 601.66 1046.76 598.71 1042.73 599.79 1041.65 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1044.24,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1026 599.38 1030.17 599.38 1032.25 595.77 1030.17 592.16 1026 592.16 1023.91 595.77 1026 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1026.03,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1011.79 607.32 1014.74 604.37 1013.66 600.34 1009.63 599.26 1006.68 602.21 1007.76 606.24 1011.79 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1009.26,604.74c-.8-.8-.8-2.09,0-2.89s2.09-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1007.35 622.98 1007.35 618.81 1003.74 616.72 1000.12 618.81 1000.12 622.98 1003.74 625.07 1007.35 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1003.74,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1015.28 637.19 1012.33 634.24 1008.31 635.32 1007.23 639.35 1010.18 642.3 1014.21 641.22 1015.28 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1012.7,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1028.47,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-137.53 908.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 1028.47,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 1265.41,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1265.17,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1265.17,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1357.46,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.53-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1265.17,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1265.17,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1265.17,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1265.17,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1265.17,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1265.17,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1265.17,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1265.13,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1232.37,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1224.32,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1243.64,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1265,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1265.26,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1286.63,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1297.9,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1305.94,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M1315.17,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1240,595.59c-4.01,4.01-8.97,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1265,585.13c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1301.17,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M1229.96,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1265,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1265.13,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1232.37,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1224.32,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1243.64,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1265,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1265.26,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1286.63,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1297.9,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1305.94,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1267.64 641.63 1263.47 641.63 1261.38 645.24 1263.47 648.85 1267.64 648.85 1269.73 645.24 1267.64 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 1265.55,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1281.85 633.69 1278.9 636.64 1279.98 640.67 1284.01 641.75 1286.96 638.8 1285.88 634.77 1281.85 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1284.38,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1286.29 618.03 1286.29 622.2 1289.9 624.29 1293.51 622.2 1293.51 618.03 1289.9 615.94 1286.29 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1289.9,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1278.35 603.82 1281.3 606.77 1285.33 605.69 1286.41 601.66 1283.46 598.71 1279.43 599.79 1278.35 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1280.93,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1262.69 599.38 1266.86 599.38 1268.95 595.77 1266.86 592.16 1262.69 592.16 1260.61 595.77 1262.69 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1262.73,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1248.48 607.32 1251.43 604.37 1250.35 600.34 1246.32 599.26 1243.37 602.21 1244.45 606.24 1248.48 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1245.95,604.74c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1244.05 622.98 1244.05 618.81 1240.43 616.72 1236.82 618.81 1236.82 622.98 1240.43 625.07 1244.05 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1240.43,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "1251.98 637.19 1249.03 634.24 1245 635.32 1243.92 639.35 1246.87 642.3 1250.9 641.22 1251.98 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1249.4,639.72c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 1265.17,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-141.15 531.39) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 1265.17,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2974.02,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 2836.86,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M3210.48,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 3073.32,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 2922.4,
    y: 546.32,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2914.5,
    y: 552.12,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2906.59,
    y: 557.92,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 2898.68,
    y: 563.71,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 2890.78,
    y: 569.51,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 2882.87,
    y: 575.31,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 2874.96,
    y: 581.11,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2867.05,
    y: 586.91,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 2859.15,
    y: 592.7,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 2851.24,
    y: 598.5,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2843.33,
    y: 604.3,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 2835.43,
    y: 610.1,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 2931.58,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 2971.45,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2936.29,609.89l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2936.41,629.33c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2973.82,629.33c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4.54-6.31,6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 2836.86,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M2836.62,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2836.62,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2928.91,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2836.62,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M2836.62,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2836.62,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M2836.62,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2836.62,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M2836.62,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2836.62,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M2836.59,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2803.82,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2795.78,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2815.09,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2836.46,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2836.72,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2858.09,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2869.35,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2877.4,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M2886.62,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2811.46,595.59c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2836.46,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2872.62,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M2801.41,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2836.46,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M2836.59,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2803.82,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2795.78,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2815.09,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2836.46,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2836.72,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2858.09,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2869.35,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2877.4,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2839.09 641.63 2834.92 641.63 2832.83 645.24 2834.92 648.85 2839.09 648.85 2841.18 645.24 2839.09 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 2837.01,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2853.3 633.69 2850.35 636.64 2851.43 640.67 2855.46 641.75 2858.41 638.8 2857.33 634.77 2853.3 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2855.83,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2857.74 618.03 2857.74 622.2 2861.35 624.29 2864.96 622.2 2864.96 618.03 2861.35 615.94 2857.74 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2861.35,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2849.8 603.82 2852.75 606.77 2856.78 605.69 2857.86 601.66 2854.91 598.71 2850.88 599.79 2849.8 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2852.38,601.29c.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2834.14 599.38 2838.32 599.38 2840.4 595.77 2838.32 592.16 2834.14 592.16 2832.06 595.77 2834.14 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2834.18,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2819.93 607.32 2822.88 604.37 2821.8 600.34 2817.77 599.26 2814.82 602.21 2815.9 606.24 2819.93 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2817.41,604.74c-.8-.8-.8-2.09,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2815.5 622.98 2815.5 618.81 2811.88 616.72 2808.27 618.81 2808.27 622.98 2811.88 625.07 2815.5 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2811.88,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "2823.43 637.19 2820.48 634.24 2816.45 635.32 2815.37 639.35 2818.32 642.3 2822.35 641.22 2823.43 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2820.85,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-157",
    cx: 2836.62,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-21.53 1132.76) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 2836.62,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-274",
    cx: 3073.56,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M3073.31,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM3073.31,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3165.61,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.53-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM3073.31,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M3073.31,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM3073.31,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M3073.31,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM3073.31,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M3073.31,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM3073.31,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M3073.28,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM3040.51,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM3032.47,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM3051.78,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM3073.15,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM3073.41,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3094.78,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM3106.05,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3114.09,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M3123.32,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM3048.15,595.59c-4.01,4.01-8.97,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3073.15,585.13c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3109.31,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M3038.11,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM3073.15,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M3073.28,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM3040.51,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM3032.47,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM3051.78,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM3073.15,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM3073.41,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3094.78,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM3106.05,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3114.09,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3075.79 641.63 3071.62 641.63 3069.53 645.24 3071.62 648.85 3075.79 648.85 3077.87 645.24 3075.79 641.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 3073.7,
    cy: 645.24,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3090 633.69 3087.05 636.64 3088.13 640.67 3092.16 641.75 3095.11 638.8 3094.03 634.77 3090 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3092.52,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3094.43 618.03 3094.43 622.2 3098.05 624.29 3101.66 622.2 3101.66 618.03 3098.05 615.94 3094.43 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3098.05,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3086.5 603.82 3089.45 606.77 3093.48 605.69 3094.56 601.66 3091.61 598.71 3087.58 599.79 3086.5 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3089.08,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3070.84 599.38 3075.01 599.38 3077.1 595.77 3075.01 592.16 3070.84 592.16 3068.75 595.77 3070.84 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3070.88,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3056.63 607.32 3059.58 604.37 3058.5 600.34 3054.47 599.26 3051.52 602.21 3052.6 606.24 3056.63 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3054.1,604.74c-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3052.19 622.98 3052.19 618.81 3048.58 616.72 3044.97 618.81 3044.97 622.98 3048.58 625.07 3052.19 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3048.58,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "3060.13 637.19 3057.18 634.24 3053.15 635.32 3052.07 639.35 3055.02 642.3 3059.05 641.22 3060.13 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M3057.55,639.72c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-160",
    cx: 3073.31,
    cy: 620.5,
    r: 18.8,
    transform: "translate(1763.3 3469.04) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 3073.31,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 514.72,
    y: 531.71,
    width: 211.04,
    height: 90.14,
    rx: 4.4,
    ry: 4.4,
    transform: "translate(1240.47 1153.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 678.79,
    y: 607.97,
    width: 33.78,
    height: 20.53,
    transform: "translate(1391.36 1236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 690.69,
    y: 527.72,
    width: 9.99,
    height: 98.94,
    rx: 4,
    ry: 4,
    transform: "translate(1391.36 1154.37) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M695.68,626.65h0c1.77,0,3.2-1.43,3.2-3.2v-92.54c0-1.77-1.43-3.2-3.2-3.2h0c-1.77,0-3.2,1.43-3.2,3.2v92.54c0,1.77,1.43,3.2,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 603.35,
    y: 607.97,
    width: 33.77,
    height: 20.53,
    transform: "translate(1240.47 1236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 615.24,
    y: 527.72,
    width: 9.99,
    height: 98.94,
    rx: 4,
    ry: 4,
    transform: "translate(1240.48 1154.37) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M620.24,626.65h0c1.77,0,3.2-1.43,3.2-3.2v-92.54c0-1.77-1.43-3.2-3.2-3.2h0c-1.77,0-3.2,1.43-3.2,3.2v92.54c0,1.77,1.43,3.2,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 527.91,
    y: 607.97,
    width: 33.77,
    height: 20.53,
    transform: "translate(1089.59 1236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 539.8,
    y: 527.72,
    width: 9.99,
    height: 98.94,
    rx: 4,
    ry: 4,
    transform: "translate(1089.59 1154.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M544.79,626.65h0c1.77,0,3.2-1.43,3.2-3.2v-92.54c0-1.77-1.43-3.2-3.2-3.2h0c-1.77,0-3.2,1.43-3.2,3.2v92.54c0,1.77,1.43,3.2,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M580.17,530.55h3.28c4.61,0,8.36,3.75,8.36,8.36v4.97h-20v-4.97c0-4.61,3.75-8.36,8.36-8.36Z",
    transform: "translate(1163.62 1074.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-265",
    cx: 581.81,
    cy: 530.55,
    rx: 10,
    ry: 6.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M573.22,529.19c0,3.11,3.85,5.63,8.59,5.63s8.59-2.52,8.59-5.63-3.85-5.63-8.59-5.63-8.59,2.52-8.59,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M248.49,312.65c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M84.88,352.79c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M122.51,256.39h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 271.8,
    y: 256.39,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M271.8,341.73v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M135.02,353.37l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M1605.8,493.22h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 1612.22,
    y: 493.22,
    width: 11.28,
    height: 143.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1637.88,518.91h0c3.15,0,5.71,2.56,5.71,5.71v7.36c0,3.15-2.56,5.71-5.71,5.71h0c-1.45,0-2.62-1.17-2.62-2.62v-13.55c0-1.45,1.17-2.62,2.62-2.62Z",
    transform: "translate(3278.86 1056.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1641.62,
    y: 520.31,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1641.73,
    y: 520.63,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1639.91,
    y: 520.31,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1640.02,
    y: 520.63,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1638.2,
    y: 520.31,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1638.31,
    y: 520.63,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1637.88,496.49h0c3.15,0,5.71,2.56,5.71,5.71v7.36c0,3.15-2.56,5.71-5.71,5.71h0c-1.45,0-2.62-1.17-2.62-2.62v-13.55c0-1.45,1.17-2.62,2.62-2.62Z",
    transform: "translate(3278.86 1011.76) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M1642.14,497.89h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1641.73,
    y: 498.21,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M1640.43,497.89h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1640.02,
    y: 498.21,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M1638.72,497.89h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1638.31,
    y: 498.21,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M3206.85,514.86h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 3218.91,
    y: 600.36,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 3213.27,
    y: 479.89,
    width: 11.28,
    height: 156.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M3242.02,540.55h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3242.67,
    y: 541.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3242.78,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3240.96,
    y: 541.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3241.07,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3239.25,
    y: 541.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3239.36,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M3242.02,518.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M3243.19,519.53h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3242.78,
    y: 519.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M3241.48,519.53h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3241.07,
    y: 519.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M3239.77,519.53h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3239.36,
    y: 519.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M2324.01,689.52c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M2306.32,531.52l-31.92-31.85c-5.06-5.04-11.91-7.88-19.05-7.88h-163.44c-2.94,0-5.33,2.39-5.33,5.33h0c0,2.94,2.39,5.33,5.33,5.33h163.44c4.32,0,8.46,1.71,11.52,4.76l31.92,31.85c3.07,3.06,4.79,7.21,4.79,11.55v22.3h10.66v-22.3c0-7.16-2.85-14.03-7.92-19.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "1370.17 541.26 1363.01 541.26 1363.01 486.41 1381.03 486.41 1370.17 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-320"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "1370.17 541.26 1363.01 541.26 1363.01 486.41 1381.03 486.41 1370.17 541.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "923.87 541.26 931.02 541.26 931.02 486.41 913.01 486.41 923.87 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-322"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "923.87 541.26 931.02 541.26 931.02 486.41 913.01 486.41 923.87 541.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M1390.8,695.77c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1381.03,579.18h-10.66v-22.3c0-4.36-1.7-8.46-4.79-11.55l-31.92-31.85c-3.08-3.07-7.17-4.76-11.52-4.76h-350.24c-4.35,0-8.44,1.69-11.52,4.76l-31.93,31.85c-3.09,3.08-4.79,7.18-4.79,11.55v22.3h-10.66v-22.3c0-7.21,2.81-13.99,7.92-19.09l31.93-31.85c5.09-5.08,11.85-7.88,19.05-7.88h350.24c7.19,0,13.96,2.8,19.05,7.88l31.92,31.85c5.11,5.1,7.92,11.88,7.92,19.09v22.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "3178.32 541.26 3171.16 541.26 3171.16 486.41 3189.18 486.41 3178.32 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-325"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "3178.32 541.26 3171.16 541.26 3171.16 486.41 3189.18 486.41 3178.32 541.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "2732.01 541.26 2739.17 541.26 2739.17 486.41 2721.15 486.41 2732.01 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-326"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "2732.01 541.26 2739.17 541.26 2739.17 486.41 2721.15 486.41 2732.01 541.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M3198.95,695.77c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M3189.18,579.18h-10.66v-22.3c0-4.36-1.7-8.46-4.79-11.55l-31.92-31.85c-3.08-3.07-7.17-4.76-11.52-4.76h-350.24c-4.35,0-8.44,1.69-11.52,4.76l-31.93,31.85c-3.09,3.08-4.79,7.18-4.79,11.55v22.3h-10.66v-22.3c0-7.21,2.81-13.99,7.92-19.09l31.93-31.85c5.09-5.08,11.85-7.88,19.05-7.88h350.24c7.19,0,13.96,2.8,19.05,7.88l31.92,31.85c5.11,5.1,7.92,11.88,7.92,19.09v22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M369.51,160.45v297h45.89c10.55,0,19.1-8.55,19.1-19.1V160.45h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M358.16,160.45v291.78h45.89c10.55,0,19.1-8.4,19.1-18.76V160.45h-64.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M369.51,214.04v243.41h28.1v-209.62c0-15.52-8.52-30.41-28.1-33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M366.41,213.83c-20.38-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM239.02,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M334.16,431.18c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,50.65.15,61.46.43v-6.3c-10.81-.28-50.42-.43-61.46-.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "165.54 517.6 33.88 517.6 33.88 590.44 66.75 590.44 66.75 629.52 74.54 629.52 74.54 590.44 116.51 590.44 116.51 629.52 124.31 629.52 124.31 590.44 135.96 590.44 165.54 517.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "133.03 565.17 66.75 565.17 66.75 525 151.29 525 133.03 565.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M125.48,560.57h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 64.8,
    y: 622.94,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 64.8,
    y: 619.65,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M62.35,629.52H28.18c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M62.35,629.52H28.18c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 276.5,
    y: 256.39,
    width: 78.69,
    height: 113.32,
    rx: 5.78,
    ry: 5.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 278.8,
    y: 267.17,
    width: 74.08,
    height: 91.77,
    rx: 4.61,
    ry: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 442.69,
    width: 1223.14,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 449.59,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 449.59,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "453.92 8.79 1658.93 8.79 1658.93 6 449.59 6 449.59 468.56 453.92 468.56 453.92 8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 2021.5,
    width: 1223.14,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 2028.4,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 2028.4,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "2032.73 8.79 3237.74 8.79 3237.74 6 2028.4 6 2028.4 468.56 2032.73 468.56 2032.73 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M405.86,227.64l13.87-16.63c9.54-11.44,14.77-25.86,14.77-40.76v-23.52s-277.71,51.79-307.5,66.84c-29.79,15.04-26.66,15.7-26.66,15.7l290.14,5.55c5.94,0,11.58-2.64,15.38-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M405.86,222.09l13.87-16.63c9.54-11.44,14.77-25.86,14.77-40.76v-23.52s-277.71,51.79-307.5,66.84c-29.79,15.04-26.66,21.26-26.66,21.26h290.14c5.94,0,11.58-2.64,15.38-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M434.5,170V46.77S156.79,171.95,127,194.93c-29.79,22.97-26.66,32.45-26.66,32.45l334.16-57.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M119.08,208.21c27.45-19.72,214.16-104.39,315.42-128.04v-33.4S156.79,171.95,127,194.93c-18.56,14.31-24.34,23.38-26.06,28.19,4.24-4.16,10.08-9.11,18.14-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M127,208.03c-29.79,15.04-26.66,21.26-26.66,21.26h290.14c5.94,0,11.58-2.64,15.38-7.2l13.87-16.63c1.22-1.46,2.36-2.98,3.44-4.53v-89.68c0-4.61-4.05-3.45-8.62-2.86-69.32,8.97-262.38,86.92-287.56,99.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 1574.82,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 1407.95,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 1387.5,
    y: 563.56,
    width: 212.43,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 1387.5,
    y: 565.68,
    width: 212.43,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 1387.5,
    y: 568.15,
    width: 212.43,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 1387.5,
    y: 605.13,
    width: 212.43,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 1387.5,
    y: 607.24,
    width: 212.43,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 1387.5,
    y: 609.72,
    width: 212.43,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 881.54,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 499.49,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 479.05,
    y: 563.56,
    width: 427.61,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 479.05,
    y: 565.68,
    width: 427.61,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 479.05,
    y: 568.15,
    width: 427.61,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 479.05,
    y: 605.13,
    width: 427.61,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 479.05,
    y: 607.24,
    width: 427.61,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 479.05,
    y: 609.72,
    width: 427.61,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 2626.65,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 2426.53,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 2346.87,
    y: 563.56,
    width: 364.13,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 2346.87,
    y: 565.68,
    width: 364.13,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 2346.87,
    y: 568.15,
    width: 364.13,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 2346.87,
    y: 605.13,
    width: 364.13,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 2346.87,
    y: 607.24,
    width: 364.13,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 2346.87,
    y: 609.72,
    width: 364.13,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M825.09,501.29h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(1696.35 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 823.83,
    y: 504,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1671.32 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 824.75,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1652.27 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 825.43,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1652.7 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 828.56,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1659.89 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 829.24,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1660.32 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 832.36,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1667.51 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 833.05,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1667.94 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 836.17,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1675.13 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 836.85,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1675.56 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 839.98,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1682.74 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 840.66,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1683.18 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 843.79,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1690.36 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 844.47,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1690.8 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 848.86,
    y: 504,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1721.38 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 849.78,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1702.33 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 850.46,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1702.76 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 853.59,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1709.95 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 854.27,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1710.38 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 857.4,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1717.57 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 858.08,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1718 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 861.2,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1725.19 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 861.89,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1725.62 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 865.01,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1732.81 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 865.69,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1733.24 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 868.82,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1740.42 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 869.5,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1740.86 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1423.71,501.29h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(2893.59 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1422.45,
    y: 504,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2868.56 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 1423.37,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2849.51 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1424.05,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2849.95 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 1427.18,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2857.13 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1427.86,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2857.56 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 1430.99,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2864.75 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1431.67,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2865.18 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 1434.8,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2872.37 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1435.48,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2872.8 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 1438.6,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2879.99 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1439.29,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2880.42 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 1442.41,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2887.61 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 1443.09,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2888.04 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1447.48,
    y: 504,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2918.62 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1448.4,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2899.57 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1449.08,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2900.01 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1452.21,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2907.19 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1452.89,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2907.63 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1456.02,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2914.81 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1456.7,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2915.24 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1459.83,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2922.43 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1460.51,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2922.86 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1463.63,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2930.05 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.32,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2930.48 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1467.44,
    y: 505.93,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2937.67 1028.22) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1468.13,
    y: 506.25,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2938.1 1017.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2028.4,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(4097.69 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 2030.2,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4078.52 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2030.9,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4063.93 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2031.42,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4064.26 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2033.82,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4069.76 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2034.34,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4070.1 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2036.74,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4075.6 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2037.26,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4075.93 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2039.65,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4081.43 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2040.18,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4081.77 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2042.57,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4087.27 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2043.09,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4087.61 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2045.49,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4093.11 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2046.01,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4093.44 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 2049.37,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4116.87 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2050.07,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4102.27 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2050.59,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4102.61 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2052.99,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4108.11 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2053.51,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4108.44 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2055.91,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4113.95 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2056.43,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4114.28 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2058.83,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4119.78 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2059.35,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4120.12 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2061.75,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4125.62 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2062.27,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4125.95 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2064.66,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4131.46 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2065.19,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4131.79 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2612.63,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(5266.14 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 2614.43,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5246.97 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2615.13,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5232.38 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2615.65,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5232.71 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2618.04,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5238.21 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2618.57,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5238.55 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2620.96,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5244.05 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2621.48,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5244.38 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2623.88,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5249.89 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2624.4,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5250.22 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2626.8,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5255.72 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2627.32,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5256.06 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 2629.72,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5261.56 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2630.24,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5261.89 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 2633.6,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5285.32 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2634.3,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5270.73 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2634.82,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5271.06 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2637.22,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5276.56 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2637.74,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5276.9 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2640.14,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5282.4 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2640.66,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5282.73 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2643.05,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5288.24 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2643.58,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5288.57 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2645.97,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5294.07 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2646.49,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5294.41 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2648.89,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5299.91 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2649.41,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5300.24 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 3196.86,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(6434.6 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 3198.65,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6415.42 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 3199.35,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6400.83 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3199.87,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6401.16 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 3202.27,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6406.67 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3202.79,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6407 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 3205.19,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6412.5 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3205.71,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6412.84 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 3208.11,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6418.34 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3208.63,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6418.67 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 3211.02,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6424.18 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3211.55,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6424.51 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 3213.94,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6430.01 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3214.46,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6430.35 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 3217.83,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6453.77 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3218.53,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6439.18 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3219.05,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6439.51 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3221.44,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6445.02 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3221.97,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6445.35 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3224.36,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6450.85 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3224.88,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6451.19 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3227.28,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6456.69 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3227.8,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6457.02 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3230.2,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6462.53 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3230.72,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6462.86 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3233.12,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6468.36 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3233.64,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6468.7 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M238.74,432.06h-22.7c-4.52,0-8.19-3.67-8.19-8.19h0c0-4.52,3.67-8.19,8.19-8.19h22.7c4.52,0,8.19,3.67,8.19,8.19h0c0,4.52-3.67,8.19-8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 212.55,
    y: 420.31,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M213.45,427.45h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M239.83,420.31h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 213.97,
    y: 421.31,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M380.6,531.84c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.11c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M366.19,523.4v108.78c0,15.1,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M395.61,245.9H116.55c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h140.47c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M385.31,529.59c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 73.19,
    y: 499.36,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M76.65,500.3h13.79c1.29,0,2.33,1.04,2.33,2.33v6.34c0,1.29-1.04,2.33-2.33,2.33h-13.79c-1.29,0-2.33-1.04-2.33-2.33v-6.34c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 89.89,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.08,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 86.92,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.11,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 83.95,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.14,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 80.98,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.17,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 78.01,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.2,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 75.03,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.23,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M27.75,470.04h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M41.27,482.36c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M38.57,430.68c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M91.39,414.97c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM122.51,257.59c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M33.63,436.86h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M16.73,389.67c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M7.69,359.52c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M128.21,249.6h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-284",
    cx: 15.79,
    cy: 306.76,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M16.55,264.22h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M8.21,272.49h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6AxTandemSingleTandem1);
export default __webpack_public_path__ + "static/media/6-Ax Tandem-Single-Tandem 1.45186c6f96b31111b680ae8e1c1de2d1.svg";
export { ForwardRef as ReactComponent };